const de = {
  '+001': '+001',
  '000000000': '000000000',
  '5-YEAR PROJECTION REDUCTION': '5-JAHRES-PROJEKTION REDUZIERUNG',
  '9 or 10 digits are allowed': '9 oder 10 Ziffern sind erlaubt',
  '9 to 13 digits are allowed': '9 bis 13 Ziffern sind erlaubt',
  ACTIVITY: 'Aktivität',
  ACTIVTY: 'AKTIVITÄT',
  ADD: 'Hinzufügen',
  ADD_COMMENT: 'Kommentar Hinzufügen',
  'AI Calc.': 'KI berechnet',
  'AI Calculation': 'KI-Berechnung',
  AIR_TEMPERATURE: 'Lufttemperatur',
  AIR_TEMPERATURE_SENSOR: 'Lufttemperatursensor',
  ALERTS: 'WARNUNGEN',
  AMMONIA_AMMONIUM: 'Ammoniak (NH3)/Ammonium (NH4+)',
  AVG: 'AVG',
  AVG_PRODUCTION: 'Durchschnittliche Produktion',
  Accept: 'Akzeptieren',
  Activated: 'Aktiviert',
  Activity: 'Aktivität',
  'Activity Log': 'Aktivitätsprotokoll',
  'Actual Energy': 'Actual Energy',
  'Add Salesforce account ID': 'Salesforce-Konto-ID hinzufügen',
  'Add a link to document': 'Link zum Dokument hinzufügen',
  'Add a link to meeting transcript': 'Link zum Meeting Transkript hinzufügen',
  'Add a link to presentation': 'Link zur Präsentation hinzufügen',
  'Add a link to report': 'Link zum Bericht hinzufügen',
  'Add link to SCC activity log screenshot': 'Link zum SCC-Aktivitätsprotokoll-Screenshot hinzufügen',
  'More than one tracking number can be added.': 'Mehr als eine Tracking-Nummer kann hinzugefügt werden.',
  'More than one order number can be added.': 'Mehr als eine Bestellnummer kann hinzugefügt werden.',
  'Engine version is set by engine expert': 'Die Engine-Version wird vom Engine-Experten festgelegt',
  'Add another dryer': 'Weiteren Trockner Hinzufügen',
  'Add another tank': 'Weiteren Tank Hinzufügen',
  'Add details for accurate setup': 'Details für korrekte Einrichtung hinzufügen',
  'Add device': 'Gerät hinzufügen',
  'Add information for setup of': 'Fügen Sie Informationen für die Einrichtung von hinzu',
  'Add manual compressor': 'Hinzufügen manueller Kompressor',
  'Add room': 'Raum hinzufügen',
  'Add spec link instead': 'Fügen Sie stattdessen einen Spezifikationslink hinzu',
  'Add system controller type': 'Systemcontroller-Typ hinzufügen',
  AddNewCompressor: 'Neuen Kompressor hinzufügen',
  'Additional compressors': 'Zusätzliche Kompressoren',
  'Alert Record': 'Alarmdatensatz',
  'Alert rule ID': 'Warnregel ID',
  'Alert rule created successfully': 'Warnregel erfolgreich erstellt',
  'Alert rule original details': 'Ursprüngliche Details der Warnregel',
  'Alert rule updated successfully': 'Warnregel erfolgreich aktualisiert',
  'Alert rules management': 'Alarmregelverwaltung',
  'Alert severity': 'Schweregrad der Warnung',
  'Alerts Record List': 'Liste der Alarmdatensätze',
  All: 'Alle',
  'Alt + Left mouse to pan': 'Alt + linke Maustaste zum Schwenken',
  'Ambient Humidity': 'Umgebungsfeuchtigkeit',
  'Ambient Temperature': 'Umgebungstemperatur',
  'Another export is already in progress': 'Ein anderer Export wird bereits durchgeführt',
  Apr: 'Apr',
  April: 'April',
  'Archive Alert': 'Archivwarnung',
  'Archive Selected Alerts': 'Ausgewählte Benachrichtigungen archivieren',
  Archived: 'Archiviert',
  'Are you sure you want to delete all data?': 'Sind Sie sicher, dass Sie alle Daten löschen möchten?',
  'Are you sure you want to delete this rule?': 'Sind Sie sicher, dass Sie diese Regel löschen möchten?',
  'Are you sure you want to mark this device as In maintenance?':
    'Sind Sie sicher, dass Sie dieses Gerät  als in Wartung befindlich markieren möchten?',
  'Are you sure you want to mark this device as not in maintenance?':
    'Sind Sie sicher, dass Sie dieses Gerät  als nicht in Wartung befindlich kennzeichnen möchten?',
  'Are you sure you want to start monitoring and alerting on this type of events?':
    'Sind Sie sicher, dass Sie die Überwachung und Benachrichtigung für diese Art von Ereignissen starten möchten?',
  'Are you sure you want to stop monitoring and alerting on this type of events?':
    'Sind Sie sicher, dass Sie die Überwachung und Benachrichtigung für diese Art von Ereignissen stoppen möchten?',
  'Are you sure you want to unarchive this alert record?':
    'Sind sie sicher, dass sie die Archivierung rückgängig machen möchten?',
  'Are you sure?': 'Sind Sie sicher?',
  'Assets Assignment': 'Asset Zuweisung',
  'Assets assignment': 'Asset Zuweisung',
  'Assets assignment data may not be properly saved':
    'Asset-Zuordnungsdaten werden möglicherweise nicht richtig gespeichert',
  'Assets assignment data saved successfully': 'Asset-Zuordnungsdaten erfolgreich gespeichert',
  Aug: 'Aug',
  Auto: 'Automatisch',
  'Auto & manually archived alerts': 'Automatisch und manuell archivierte Warnungen',
  'Available flow subtitle': 'Verfügbar',
  Avg: 'Avg',
  'Avg Production': 'Durchschnittliche Produktion',
  BACK_TO_LIST: 'Back to list',
  BLOWER_SPEED: 'Gebläsedrehzahl',
  BLOWER_TARGET_SPEED: 'Gebläsezieldrehzahl',
  BYPASS_VALVE: 'Überbrückungsventil',
  BYPASS_VALVE_OPENING: 'Bypassventilöffnung',
  'Background Data Leakage': 'Hintergrund Datenleck',
  Bar: 'Bar',
  Baseline: 'Referenzwert',
  'Baseline Period': 'Referenzzeitraum',
  'Baseline Period From': 'Referenzzeitraum ab',
  'Block stage': 'Blockierstatus',
  'Blocked from': 'Blockiert seit',
  Booster: 'Verstärker',
  CANCEL: 'Abbrechen',
  CANCEL_TEST: 'Test Abbrechen',
  CENTRIFUGAL_TARGET_SETPOINT: 'Zentrifugales Ziel-Sollwert',
  CFM: 'CFM',
  CHANGE_COMPRESSOR_STATE_FAILED: 'Änderung des Stromversorgungszustands des Kompressors {{deviceName}} fehlgeschlagen',
  CLOSE: 'Schließen',
  'CO2 Reduction': 'CO2-Reduzierung',
  COMMAND_FAILED_OFFLINE: 'Offline fehlgeschlagen',
  COMMAND_FAILED_TIME_OUT: 'Zeitüberschreitung fehlgeschlagen',
  COMMAND_FAILED_TO_UPDATE: 'Aktualisierung fehlgeschlagen',
  COMMAND_IGNORED_UNCHANGED_VALUE: 'Unveränderter Wert ignoriert',
  COMMAND_RECEIVED_AND_UPDATED: 'Erhalten und Aktualisiert',
  COMMAND_WAITING_FOR_DELIVER: 'Auf Lieferung warten',
  CONNECTION_ERROR: 'Verbindungsfehler',
  CONTROLLABLE: 'Steuerbar',
  CONTROL_MODE: 'Steuermodus',
  CURRENT: 'Aktuell',
  CURRENT_VALVE_POSITION: 'Aktuelle Ventilposition',
  CURRENT_YEAR: 'AKTUELLES JAHR',
  CYCLE: 'ZYKLUS',
  Cancel: 'Abbrechen',
  'Cannot proceed: Missing Salesforce Account ID': 'Kann nicht fortfahren: Fehlende Salesforce-Konto-ID',
  Celsius: 'Celsius',
  'Changes can be made in Station Control Center only.':
    'Änderungen können nur in der Steuerzentrale vorgenommen werden.',
  'Changes will not be saved. Are you sure?': 'Änderungen werden nicht gespeichert. Sind Sie sicher?',
  'Choose a device with the above-selected monitored parameter. Select multiple devices to create a rule on a calculated parameter (e.g. Pressure difference between devices).':
    'Wählen Sie ein Gerät mit dem oben ausgewählten überwachten Parameter. Wählen Sie mehrere Geräte aus, um eine Regel für einen berechneten Parameter zu erstellen (z. B. Druckunterschied zwischen Geräten).',
  'Choose only Power parameters to view the Stack layout. You cannot choose the station total power':
    'Wählen Sie nur Leistungsparameter aus, um das Stapellayout anzuzeigen. Sie können die Gesamtleistung der Station nicht auswählen',
  'Choose the operand and the target value threshold to trigger the alerts.':
    'Wählen Sie den Operanden und den Zielwertschwellenwert zum Auslösen der Warnungen.',
  'Choose the parameter you wish to monitor.': 'Wählen Sie den Parameter aus, den Sie überwachen möchten.',
  City: 'Stadt',
  'Clear all engine configurations': 'Alle Motorkonfigurationen löschen',
  'Click a pipe to add assets. Right-click sensors, filters or valves to edit.':
    'Klicken Sie auf ein Rohr, um Assets hinzuzufügen. Klicken Sie mit der rechten Maustaste auf Sensoren, Filter oder Ventile, um sie zu bearbeiten.',
  Close: 'Schließen',
  'Closed Valve - Connected': 'Ventil geschlossen – eingeschaltet',
  'Combo Sensor': 'Kombi Sensor',
  'Communication Issues': 'Kommunikationsprobleme',
  'Comp. Est.': 'Komp. Geschätzt',
  'Compare with (Show me from-to)': 'Vergleichen mit (Zeige mir von-bis)',
  Completed: 'Abgeschlossen',
  'Complex Pipes': 'Komplexe Rohre',
  Compressor: 'Kompressor',
  'Compressor Estimation': 'Kompressorschätzung',
  'Compressor Info': 'Kompressor Info',
  'Compressor Type': 'Kompressor Typ',
  'Compressor kW based calculation': 'Kompressor-kW-basierte Berechnung',
  'Compressor number is required': 'Kompressornummer ist erforderlich',
  Compressors: 'Kompressoren',
  'Compressors in this room': 'Kompressoren in diesem Raum',
  "Compressors' Issues": 'Probleme mit Kompressor',
  Connected: 'Verbunden',
  'Contact us if you have any questions at:': 'Kontaktieren Sie uns bei Fragen unter:',
  Continue: 'Weiter',
  ControlPrep: 'Steuerungs-Vorbereitung',
  Controllable: 'Steuerbar',
  Controlled: 'Gesteuert',
  Controller: 'Controller',
  'Controller Mode': 'Steuermodus',
  'Controllers Missing': 'Fehlende Controller',
  "Controllers' Issues": 'Controller-Probleme',
  Cooling: 'Kühlung',
  'Cooling type': 'Kühlungstyp',
  Create: 'Erstellen',
  'Create Station': 'Station erstellen',
  'Create a custom rule': 'Eine benutzerdefinierte Regel erstellen',
  'Create and Activate': 'Erstellen und Aktivieren',
  'Create new rule': 'Neue Regel erstellen',
  'Create new user': 'Neuen Benutzer erstellen',
  'Creation date': 'Datum der Erstellung',
  Custom: 'Benutzerdefiniert',
  'Customer Not Responding': 'Kunde antwortet nicht',
  DAY: 'DAY',
  DEVICE_STATUS_LOAD: 'Gerät im Status Laden',
  DEVICE_STATUS_UNLOAD: 'Gerät im Zustand Entladen',
  'DEW POINT': 'TAUPUNKT',
  DEW_POINT: 'Taupunkt',
  DEW_POINT_TEMPERATURE: 'Taupunkttemperatur',
  DISSOLVED_OXYGEN: 'Gelöster Sauerstoff',
  DRYER_BLOWER_ACTIVITY: 'Aktivität des Trocknergebläses',
  DRYER_DESICCANT_SERVICE_HOURS: 'Trockner Trockenmittel Servicestunden',
  DRYER_EXTENDED_ACTIVITY: 'Verlängerte Aktivität des Trocknergebläses',
  DRYER_FILTER_SERVICE_HOURS: 'Serviceintervalle für Trocknerfilter',
  DRYER_HEATER_ACTIVITY: 'Aktivität der Trocknerheizung',
  DRYER_LEFT_TOWER_ACTIVITY: 'Trockner links Turmaktivität',
  DRYER_OPERATION_MODE: 'Betriebsmodus',
  DRYER_RIGHT_TOWER_ACTIVITY: 'Trockner rechts Turmaktivität',
  DRYER_TEMPERATURE_SETPOINT_CELSIUS: 'Trockner-Temperatursollwert Celsius',
  DRYER_VALVE_SERVICE_HOURS: 'Trocknerventil-Service-Stunden',
  DUTY: 'TÄTIGKEIT',
  'Data export failed': 'Datenexport fehlgeschlagen',
  'Date Created': 'Datum der Erstellung',
  'Date Fired': 'Kündigungsdatum',
  'Date created': 'Erstellungsdatum',
  Deactivated: 'Deaktiviert',
  Dec: 'Dez',
  Decline: 'Ablehnen',
  'Define Site Configuration': 'Standortkonfiguration definieren',
  'Define site configuration': 'Standortkonfiguration definieren',
  'Define the logic for triggering alerts of different severity levels.':
    'Definieren Sie die Logik zum Auslösen von Warnungen mit unterschiedlichen Schweregraden.',
  Degradation: 'Verschlechterung',
  'Delete compressor': 'Löschkompressor',
  'Delete user': 'Benutzer löschen',
  Deprecated: 'Abgelehnt',
  Description: 'Beschreibung',
  Desiccant: 'Trockenmittel',
  'Desiccant Air Dryer': 'Trockenmittellufttrockner',
  Design: 'Gestaltung',
  'Design Mismatch': 'Design-Fehlanpassung',
  Device: 'Gerät',
  'Device Details': 'Gerätedetails',
  'Device name': 'Name des Geräts',
  'Devices Names': 'Gerätenamen',
  'Dew Point Sensor': 'Tau Punkt Sensor',
  'Dew point temperature': 'Taupunkttemperatur',
  'Dew temp': 'Tautemperatur',
  'Dial code': 'Vorwahl',
  Diff: 'Diff',
  Differences: 'Unterschiede',
  'Discard changes': 'Änderungen verwerfen',
  Disconnected: 'Abgeschaltet',
  Dismiss: 'Ablehnen',
  'Displayed alerts': 'Angezeigte Warnungen',
  "Don't have a URL?": 'Haben Sie keine URL?',
  Done: 'Erledigt',
  'Drive Type': 'Antriebstyp',
  Dry: 'Trocken',
  'Dry Air Tank': 'Trocken Luft Tank',
  'Dry tank': 'Trocken Tank',
  'Dryers in the room': 'Trockner im Raum',
  'Duration (if this rule lasts for x time)': 'Dauer (dieser Regel dauert x Zeit)',
  'Dynamic Controller': 'Dynamischer Regler',
  'Dynamic Controller is Activated': 'Dynamischer Regler ist aktiviert',
  'Dynamic Controller is Deactivated': 'Dynamischer Regler ist deaktiviert',
  'Dynamic Controller is Disabled - Under Maintenance': 'Dynamischer Regler ist deaktiviert – Wird gewartet',
  'Dynamic Controller is Disabled by Cloud Control Switch':
    'Dynamischer Regler ist deaktiviert durch den Wolke Steuerschalter',
  'Dynamic Controller is Disabled by Local Control Switch':
    'Dynamischer Regler ist deaktiviert durch den lokalem Steuerschalter',
  'E.g. 6.4': 'Z.B. 6.4',
  'E.g. Doe': 'Z.B. Doe',
  'E.g. High than usual flow causes pressure drop':
    'Z.B. Ein höherer Durchfluss als üblich verursacht einen Druckabfall',
  'E.g. High then usual flow causes pressure drop':
    'Z.B. Ein höherer Durchfluss als üblich verursacht einen Druckabfall',
  'E.g. John': 'Z.B. Johannes',
  'E.g. Try do the following...': 'Z.B. Versuchen Sie Folgendes...',
  'EB Issues': 'EB-Themen',
  'ECO RATING': 'ECO-BEWERTUNG',
  END_TEST: 'Test beenden',
  ENERGY_SAVINGS: 'Energie einsparen',
  ENGINE: 'Motor',
  ESTIMATED_FLOW: 'Geschätzter Durchfluss',
  EST_FLOW: 'Gesch. Durchfluss',
  EST_INVERTER_SPEED: 'Gesch. Wechselrichterdrehzahl',
  EST_POWER: 'Gesch. Leistung',
  EST_SPECIFIC_POWER: 'Gesch. Spezifische Leistung',
  EXPECTED_VALUE_READING_VALUE: 'Erwartet:{{expectedValue}}kW - Lesen: {{readingValue}}kW',
  EXTERIOR_AMBIENT_TEMPERATURE: 'Aussenumgebungstemperatur',
  'Each compressor must have a unique number': 'Jeder Kompressor muss eine eindeutige Nummer haben',
  'Each room must have at least one compressor': 'Jeder Raum muss mindestens einen Kompressor haben',
  'Easily configure a precise, customer-specific site map.':
    'Konfigurieren Sie auf einfache Weise eine präzise, kundenspezifische Sitemap.',
  "Eco plant's logo": 'Logo von Eco Anlage',
  'EcoPlant 2020. All right reserved.': 'nan',
  'EcoPlant 2025. All right reserved.': 'EcoPlant 2025. Alle Rechte vorbehalten.',
  Edit: 'Bearbeiten',
  'Edit Account Manager': 'Account Manager bearbeiten',
  'Edit Map': 'Karte Bearbeiten',
  'Edit contact person': 'Kontaktperson bearbeiten',
  'Edit site address': 'Adresse der Bearbeitungsseite',
  'Edit this Alert rule appearance': 'Dieses Erscheinungsbild der Alert-Regel bearbeiten',
  Email: 'E-Mail-Adresse',
  'Email Address': 'E-Mail-Adresse',
  'End Date': 'Enddatum',
  Energy: 'Energie',
  'Energy Efficiency': 'Energie-Effizienz',
  'Energy Saving': 'Energieeinsparung',
  EnergySavings: 'Energieeinsparungen',
  'Engine ready': 'Motor bereit',
  'Enter a verification code': 'Geben Sie einen Bestätigungscode ein',
  'Enter details manually': 'Details manuell eingeben',
  'Enter value': 'Wert eingeben',
  'Exit & Discard': 'Beenden & Verwerfen',
  'Exit & Save Draft': 'Ausfahrt & Entwurf Speichern',
  'Exit Edit Mode': 'Bearbeitungsmodus beenden',
  Expired: 'Abgelaufen',
  Export: 'Exportieren',
  'External Control System': 'Externes Steuerungssystem',
  FAILED: 'Gescheitert',
  FLOW: 'Durchfluss',
  FREQUENCY: 'Häufigkeit',
  Fahrenheit: 'Fahrenheit',
  'Failed Offline': 'Offline fehlgeschlagen',
  'Failed TimeOut': 'Fehlgeschlagene Zeitüberschreitung',
  'Failed To Update': 'Aktualisierung fehlgeschlagen',
  'Failed changing maintenance mode': 'Ändern des Wartungsmodus fehlgeschlagen',
  'Failed retrieving commands history': 'Befehle aus dem Verlauf konnten nicht abgerufen werden',
  FailedToActivateDynamicController: 'Dynamischer Controller konnte nicht aktiviert werden',
  'Failed to block stage': 'Blockierung der Stufe fehlgeschlagen',
  'Failed to change activation status': 'Änderung des Aktivierungsstatus fehlgeschlagen',
  FailedToDeactivateDynamicController: 'Deaktivierung des dynamischen Controllers fehlgeschlagen',
  CompressorInMaintenancePreventsActivation:
    'Der dynamische Regler kann nicht aktiviert werden, da sich die Kompressoren im Wartungsmodus befinden oder die Priorität ignoriert wurde',

  // No Flow Control Notification Modal
  noFlowControlNotificationTitle: 'Die dynamische Steuerung für diese Station wurde aktualisiert.',
  noFlowControlNotificationSubtitle:
    'Wir verwenden jetzt geschätzten Durchfluss ("kein Durchfluss") anstelle der Durchflusssensor-Steuerung. Folglich:',
  noFlowControlKpisRecalculated:
    'Durchfluss- und spezifische Leistungs-KPIs werden neu berechnet, sodass sich die Werte ändern können.',
  noFlowControlSavingsAdjusted: 'Die Einsparungen werden mit derselben Basis-spezifischen Leistung angepasst.',
  noFlowControlSensorsDifferent:
    'Durchflusssensoren zeigen weiterhin Messwerte an, aber sie beeinflussen die KPIs nicht mehr und erscheinen anders auf der Karte.',
  noFlowControlHistoricalKpis: 'Historische Durchflusssensor-KPIs bleiben bis zur Änderung verfügbar.',
  noFlowControlClosingMessage:
    'Diese Aktualisierung trägt dazu bei, eine reibungslose Steuerung und konstante Leistung zu gewährleisten. Viel Spaß mit der Aktualisierung!',
  noFlowControlOkButton: 'OK, verstanden!',

  'Failed to delete rule': 'Regel konnte nicht gelöscht werden',
  'Failed to fetch account data. Please try again.':
    'Kontendaten konnten nicht abgerufen werden. Bitte versuchen Sie es erneut.',
  'Failed to fetch model specifications. Some dropdown options may not be available.':
    'Modellspezifikationen konnten nicht abgerufen werden. Einige Dropdown-Optionen sind möglicherweise nicht verfügbar.',
  'Failed to save': 'Speichern fehlgeschlagen',
  'Failed to save assets assignment data. Please try again.':
    'Zuordnungsdaten für Assets konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.',
  'Failed to save progress. Please try again.':
    'Fortschritt konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
  'Failed to save, your changes will be lost': 'Speichern fehlgeschlagen, Ihre Änderungen gehen verloren',
  Feb: 'Februar',
  Filter: 'Filter',
  'Filter by device': 'Nach Gerät filtern',
  'Filter by rule': 'Nach Regeln filtern',
  'Filter by source': 'Nach Quelle filtern',
  'First name': 'Vorname',
  Flow: 'Durchfluss',
  'Flow Levels': 'Durchflussmengen',
  'Flow Sensor': 'Durchfluss Sensor',
  'Flow based on Flow sensor avg at the end of the station':
    'Durchfluss basierend auf dem Durchflusssensordurchschnitt am Ende der Station',
  'Flow sum': 'Durchfluss-Summe',
  FlowUpper: 'Durchfluss',
  'Follow the math order of operations.': 'Befolgen Sie die mathematische Reihenfolge der Operationen.',
  'For technical support email us at:': 'Für technische Unterstützung senden Sie uns eine E-Mail an:',
  'Forgot Password': 'Passwort vergessen',
  'Full Name': 'Vollständiger Name',
  'Full name': 'Vollständiger Name',
  'Function is disabled since Engine Mode is Activated': 'Funktion ist deaktiviert, da der Motormodus aktiviert ist.',
  'Function is disabled since changing power state is not supported on this compressor.':
    'Funktion ist deaktiviert, da die Änderung des Stromversorgungsstatus von diesem Kompressor nicht unterstützt wird.',
  GHG: 'THG',
  GPM: 'GPM',
  Gallon: 'Gallone',
  'Given description': 'Gegebene Beschreibung',
  'Given rule name (Title)': 'Name der gegebenen Regel (Titel)',
  HORSE_POWER: 'Pferdestärken',
  HP: 'HP',
  HUMIDITY: 'Relative Feuchtigkeit',
  'Have a spec URL instead?': 'Haben Sie stattdessen eine Spezifikations-URL?',
  High: 'Hoch',
  Holiday: 'Urlaub',
  Horsepower: 'Pferdestärken',
  Hz: 'Hz',
  'I/O': 'E/A',
  IN: 'Ein',
  'IN MAINTENANCE': 'IN WARTUNG',
  INFLUENT_FLOW: 'Einlassdurchfluss',
  INIT_SCENARIO: 'Init-Szenario',
  INLET_VALVE: 'Einlassventil',
  INLET_VALVE_OPENING: 'Einlassventilöffnung',
  INLET_WATER_TEMPERATURE: 'Einlasswassertemperatur',
  INSTALLATION_VALIDATION_IN_PROGRESS_CONTENT:
    'Anderer Benutzer hat diese Validierung bereits gestartet. Bitte aktualisieren Sie, um den aktuellen Status zu sehen.',
  INSTALLATION_VALIDATION_IN_PROGRESS_TITLE: 'Validierung im Gange',
  INSTALLATION_VALIDATION_SUBMITTED_CONTENT:
    'Anderer Benutzer hat diese Validierung bereits eingereicht. Bitte aktualisieren Sie, um den aktuellen Status zu sehen.',
  INSTALLATION_VALIDATION_SUBMITTED_TITLE: 'Validierung bereits eingereicht',
  INSTALLATION_VALIDATION_TITLE: 'Validierung der Installation',
  INVERTER_SPEED: 'Wechselrichterdrehzahl',
  'Ignored Unchanged Value': 'Ignoriert Unveränderter Wert',
  Immediately: 'Sofort',
  Imperial: 'Kaiserlich',
  'In maintenance': 'In Wartung',
  InProgress: 'In Arbeit',
  'Inlet Water Temperature': 'Einlasswassertemperatur',
  Insight: 'Einsicht',
  Installation: 'Einrichtung',
  'Installation Validation Fails / Control Validation': 'Installationsvalidierung schlägt fehl / Steuerungsvalidierung',
  Integration: 'Integration',
  'Inverter speed': 'Wechselrichterdrehzahl',
  'Investigate by Devices': 'Nach Geräte untersuchen',
  Investigation: 'Untersuchung',
  'Is there more than 1 target pressure?': 'Gibt es mehr als 1 Zieldruck?',
  Jan: 'Jan',
  'John@domain.com': 'John@domain.com',
  Jul: 'Jul',
  Jun: 'Jun',
  'Keep Alive': 'Am Leben erhalten',
  'LIFE TIME SAVINGS': 'LEBENSZEITEINSPARUNG',
  LOAD: 'Laden',
  LOAD_HOURS: 'Ladestunden',
  LOAD_TEST: 'Belastungstest',
  LOW_RISK: 'Niedriges Risiko',
  'Last 24 hours': 'Letzte 24 Stunden',
  'Last 30 days': 'Letzte 30 Tage',
  'Last 7 days': 'Letzte 7 Tage',
  'Last 90 days': 'Letzte 90 Tage',
  'Last Updated': 'Zuletzt aktualisiert',
  'Last commands': 'Letzte Befehle',
  'Last name': 'Nachname',
  'Last set point': 'Letzter Sollwert',
  'Last updated': 'Zuletzt aktualisiert',
  'Last updated on:': 'Zuletzt aktualisiert am:',
  'Learn More And Enable Leakage': 'Mehr erfahren und Leakage ermöglichen',
  'Left mouse to zoom': 'Linke Maustaste zum Zoomen',
  'License Agreement': 'Lizenzvereinbarung',
  Lifecycle: 'Lebenszyklus',
  'Link to presentation': 'Link zur Präsentation',
  Liter: 'Liter',
  Load: 'Laden',
  'Load hours': 'Ladestunden',
  'Load more': 'Mehr laden',
  Loading: 'Wird geladen',
  'Loading...': 'Wird geladen...',
  'Log out': 'Abmelden',
  Login: 'Anmelden',
  'Login with SSO': 'Anmeldung mit SSO',
  LoginFailureNoStations:
    'Ihr Anmeldeversuch war nicht erfolgreich, da Ihrem Konto derzeit keine Stationen zugewiesen sind. Bitte wenden Sie sich an Ihren IT-Administrator, um Zugriff auf die erforderlichen Stationen zu erhalten.',
  LoginFailurePasswordError:
    'Ihr Anmeldeversuch war nicht erfolgreich. Systemfehler: {{error}} Wenn Ihre Organisation Single Sign-On (SSO) verwendet, versuchen Sie bitte, sich über die SSO-Option anzumelden.',
  LoginFailureUnhautorizedSSO:
    'Ihr Anmeldeversuch war nicht erfolgreich, weil Ihr SSO-Konto nicht genehmigt wurde. Bitte versuchen Sie, sich mit einem anderen SSO-Konto anzumelden, oder verwenden Sie die Passwortanmeldemethode.',
  Low: 'Niedrig',
  MAINTENANCE: 'WARTUNG',
  MAXIMUM_PRESSURE: 'Maximaler Druck',
  MINIMUM_PRESSURE: 'Minimaler Druck',
  MODERATE_RISK: 'Mittleres Risiko',
  MONTH: 'MONAT',
  'MONTH AVG': 'MONAT AVG',
  MT: 'MT',
  'MT GHG': 'MT THG',
  MTD: 'MTD',
  MainPressure: 'Hauptseite',
  Maintenance: 'Wartung',
  'Maintenance Event': 'Wartungsereignis',
  'Manage Users': 'Benutzer verwalten',
  Manual: 'Handbetätigt',
  Manufacturer: 'Hersteller',
  'Manufacturer and Custom Alerts with Service Severity':
    'Hersteller- und benutzerdefinierte Warnungen mit Service-Schweregrad',
  'Manufacturer and Custom Alerts with Shutdown Severity':
    'Hersteller- und benutzerdefinierte Alarme mit Abschaltschwere',
  'Manufacturer and Custom Alerts with Warning Severity':
    'Hersteller- und benutzerdefinierte Warnungen mit Warnschweregrad',
  Map: 'Karte',
  Mar: 'März',
  'Max Available': 'Maximal verfügbar',
  'Max set point': 'Maximaler Sollwert',
  May: 'Mai',
  'Measurement system': 'Messsystem',
  Metric: 'Metrisch',
  Min: 'Min',
  'Min / Max': 'Min / Max',
  'Min set point': 'Minimaler Sollwert',
  Minutes: 'Minuten',
  'Missing Contract#': 'Fehlende Vertragsnummer',
  'Missing PO#': 'Fehlende PO#',
  'Missing Parts': 'Fehlende Teile',
  Model: 'Modell',
  'Model spec': 'Modellspezifikation',
  Moderate: 'Mittel',
  Monitor: 'Monitor',
  'Month Over Month avg Flow Trend': 'Monatlicher durchschnittlicher Durchflusstrend',
  Monthly: 'Monatlich',
  'Move stage failed': 'Umzugsphase fehlgeschlagen',
  'Move stage success!': 'Bühnenerfolg bewegen',
  'Move to': 'Umzug nach',
  'Moving stage...': 'Bewegte Bühne.',
  'My rules': 'Meine Regeln',
  'NEXT SERVICE': 'NÄCHSTER SERVICE',
  NEXT_SERVICE_HOURS: 'Nächste Servicestunden',
  NEXT_SERVICE_IN: 'Nächste Wartung in',
  NEXT_SERVICE_NAME: 'Name nächster Service',
  NEXT_SERVICE_TYPE: 'Nächste Wartung Art',
  NITRATE_NO_3: 'Nitrat (NO3-)',
  NITRITE_NO_2: 'Nitrit (NO2-)',
  NOTCONTROLLABLE: 'Nicht steuerbar',
  NOT_CONTROLLABLE: 'Nicht steuerbar',
  NOT_INCLUDE_SENSOR: 'Sensor nicht enthalten',
  NOT_TESTED: 'Nicht getestet',
  NO_POWER_SENSOR: 'Kein Leistungssensor',
  NO_STATE: 'Kein Status',
  'Name the alerts and set their severity.': 'Warnungen benennen und ihren Schweregrad festlegen.',
  New: 'Neu',
  'New Alert': 'Neue Warnung',
  'New Value': 'Neuer Wert',
  No: 'Nein',
  'No Controller': 'Kein Controller',
  'No Internal Kickoff Date': 'Kein internes Kickoff-Datum',
  'No State': 'Kein Status',
  'No accounts available': 'Keine Konten verfügbar',
  'No alerts to show for this severity type.': 'Keine anzuzeigenden Warnungen für diesen Schweregradtyp.',
  'No archived alerts yet.': 'Noch keine abgelegten Warnungen.',
  'No commands to show': 'Keine Befehle zu zeigen',
  'No data': 'Keine Daten',
  'No data to show for this time frame and parameters.':
    'Für diesen Zeitraum und diese Parameter sind keine Daten anzuzeigen.',
  'No more alerts to show': 'Keine weiteren Warnungen zum Anzeigen',
  'No rules to display': 'Keine Regeln zum Anzeigen',
  NoState: 'Kein Status',
  'Not Connected': 'Nicht verbunden',
  'Not Controlled': 'Nicht gesteuert',
  'Not connected': 'Nicht verbunden',
  'Not controllable': 'Nicht steuerbar',
  'Note: Each pressure type requires a separate site survey':
    'Hinweis: Für jeden Drucktyp ist eine separate Standortbestimmung erforderlich.',
  'Nothing to update. No changes were made to the information':
    'Es gibt nichts zu aktualisieren. Es wurden keine Änderungen an den Informationen vorgenommen',
  Notifications: 'Benachrichtigungen',
  'Notifies on Periodic Shutdown event creation, 1 day before the event':
    'Benachrichtigt bei der Erstellung des Ereignisses "Regelmäßige Abschaltung", 1 Tag vor dem Ereignis',
  "Notifies when a Device's Maintenance flag is changed":
    'Benachrichtigt, wenn das Wartungskennzeichen eines Geräts geändert wird',
  'Notifies when a Report is generated': 'Benachrichtigt, wenn ein Bericht erstellt wird',
  'Notifies when a Station is switched On or Off': 'Benachrichtigt, wenn eine Station ein- oder ausgeschaltet wird',
  'Notifies when a new Insight Event is created': 'Benachrichtigt, wenn ein neues Insight-Ereignis erstellt wird',
  'Notifies when the Dynamic Controller is turned On or Off':
    'Benachrichtigt, wenn der dynamische Controller ein- oder ausgeschaltet wird',
  Nov: 'Nov',
  Number: 'Nummer',
  'Number of compressor rooms': 'Anzahl der Kompressorräume',
  'Number of entry points to main header': 'Anzahl der Einstiegspunkte zum Hauptkopf',
  OFF: 'Aus',
  OFFERING: 'Angebot',
  OIL_TEMPERATURE: 'Öl Temperatur',
  ON: 'Ein',
  ON_OFF: 'Ein/Aus',
  OPEN: 'Öffnen',
  OPERATION: 'BETRIEB',
  OPERATION_MODE: 'Betriebsmodus',
  OR: 'OR',
  OUT: 'Aus',
  OUTLET_WATER_TEMPERATURE: 'Auslasswassertemperatur',
  OXIDATION_REDUCTION_POTENTIAL: 'Sauerstoffreduktionspotenzial',
  Oct: 'Okt',
  Off: 'Aus',
  'Oil temp': 'Öltemperatur',
  'Oil temperature': 'Öl Temperatur',
  On: 'Ein',
  'On/Off': 'Ein/Aus',
  'Only numbers are allowed!': 'Nur Zahlen sind erlaubt!',
  Open: 'Offen',
  'Open Insights': 'Einblicke öffnen',
  'Open Valve - Connected': 'Ventil offen – eingeschaltet',
  Operand: 'Operand',
  Operation: 'Operation',
  Opportunity: 'Gelegenheit',
  Optimize: 'Optimieren Sie',
  'Or contact us via:': 'Kontaktieren Sie uns über:',
  OrderPlacement: 'Platzierung der Bestellung',
  'Original description': 'Ursprüngliche Beschreibung',
  'Original rule name (Title)': 'Name der ursprünglichen Regel (Titel)',
  Other: 'Andere',
  'Outlet Water Temperature': 'Auslasswassertemperatur',
  Overdue: 'Überfällig',
  'P&ID Draft': 'P&ID-Entwurf',
  PASSED: 'Bestanden',
  PEAK_PRODUCTION: 'Spitzenproduktion',
  PLANNED_AVAILABILITY: 'Geplante Verfügbarkeit',
  PLANT: 'Anlage',
  POWER: 'Leistung',
  POWERED_ON: 'Leistung ein',
  PRESSURE: 'Druck',
  'PRESSURE SET POINTS': 'DRUCKSOLLWERTE',
  PREVIOUS_YEAR: 'VORJAHR',
  PSI: 'Psi',
  P_H: 'PH',
  Parameter: 'Parameter',
  Password: 'Passwort',
  'Paste link to spec': 'Link zur Spezifikation einfügen',
  'Peak Production': 'Spitzenproduktion',
  'Peak production subtitle': 'Spitzenproduktion',
  'Periods compare': 'Perioden vergleichen',
  Platform: 'Plattform',
  'Please add a link': 'Fügen Sie einen Link hinzu',
  'Please add a valid link': 'Fügen Sie einen gültigen Link hinzu',
  'Please choose a role': 'Wählen Sie eine Rolle',
  'Please choose a station': 'Wählen Sie eine Station',
  'Please choose a time period and at least one parameter.':
    'Wählen Sie einen Zeitraum und mindestens einen Parameter.',
  'Please choose at least one graph.': 'Wählen Sie mindestens ein Diagramm aus.',
  'Please choose your measurement system': 'Wählen Sie Ihr Messsystem',
  'Please enter ZIP code': 'Postleitzahl eingeben',
  'Please enter a valid URL': 'Bitte geben Sie eine gültige URL ein',
  'Please enter a valid ZIP Code': 'Geben Sie eine gültige Postleitzahl ein',
  'Please enter a valid email address': 'Geben Sie eine gültige E-Mail Adresse ein',
  'Please enter city': 'Stadt eingeben',
  'Please enter email': 'E-Mail eingeben',
  'Please enter full name': 'Vollständigen Namen eingeben',
  'Please enter number': 'Nummer eingeben',
  'Please enter only numbers': 'Nur Zahlen eingeben',
  'Please enter state': 'Staat eingeben',
  'Please enter street address': 'Geben Sie Ihre Adresse ein',
  'Please fix validation errors before submitting': 'Beheben Sie Validierungsfehler vor dem Absenden',
  'Please input a valid email address': 'Geben Sie eine gültige E-Mail-Adresse ein',
  'Please input your dial code': 'Geben Sie Ihre Vorwahl ein',
  'Please input your email': 'Geben Sie Ihre E-Mail-Adresse ein',
  'Please input your first name': 'Geben Sie Ihren Vornamen ein',
  'Please input your last name': 'Geben Sie Ihren Nachnamen ein',
  'Please input your number': 'Geben Sie Ihre Nummer ein',
  'Please select a tier': 'Wählen Sie eine Stufe',
  'Please try again later.': 'Versuchen Sie es später noch einmal',
  Power: 'Leistung',
  PowerUpper: 'Leistung',
  Pressure: 'Druck',
  'Pressure Drop': 'Druckabfall',
  'Pressure Sensor': 'Druck Sensor',
  'Pressure drop': 'Druckabfall',
  Priority: 'Priorität',
  'Production Floor': 'Produktionshalle',
  'Progress saved successfully.': 'Fortschritt erfolgreich gespeichert',
  REALTIME_SYSTEM_CAPACITY: 'Echtzeit-Systemkapazität',
  RECOMMENDATION: 'EMPFEHLUNG',
  'RELATIVE POSITION': 'RELATIVE POSITION',
  REPORTS: 'Berichte',
  REPORT_SUBMIT_ERROR: 'Bericht wurde nicht eingereicht',
  REPORT_SUBMIT_SUCCESS: 'Bericht erfolgreich übermittelt',
  RPM: 'RPM',
  RUN_HOURS: 'Betriebsstunden',
  'Realtime Production': 'Echtzeitproduktion',
  Reason: 'Grund',
  'Received And Updated': 'Erhalten und aktualisiert',
  'Received during maintenance': 'Während der Wartung erhalten',
  Refresh: 'Auffrischen',
  'Refresh Map': 'Karte aktualisieren',
  Refrigerated: 'Gekühlt',
  'Refrigerated Air Dryer': 'Kältelufttrockner',
  Reject: 'Ablehnen',
  Remove: 'Entfernen',
  'Report contains to many records': 'Bericht enthält zu viele Datensätze',
  'Report export': 'Exportbericht',
  'Report export preferences': 'Exportbericht Einstellungen',
  'Required to complete stage': 'Für den Abschluss der Etappe erforderlich',
  'Reset zoom': 'Zoom zurücksetzen',
  'Restore default': 'Standard wiederherstellen',
  Revert: 'Zurücksetzen',
  Risk: 'Risiko',
  Role: 'Rolle',
  'Rule activation status': 'Status der Regelaktivierung',
  'Rule condition:': 'Regelbedingung:',
  'Rule name (Title)': 'Regelname (Titel)',
  Run: 'Betreiben',
  'Run hours': 'Betriebsstunden',
  SAVE_CHANGES: 'Speichern von Änderungen',
  SCC: 'SCC',
  SENSOR_READING: 'Sensormessung',
  SETTINGS: 'Einstellungen',
  SHOWING_CURRENT_MONTH_ACCUMULATED_DATA: 'Anzeige der kumulierten Daten des aktuellen Monats',
  SMS: 'SMS',
  'SMS with a verification code was sent to your phone':
    'Eine SMS mit einem Bestätigungscode wurde an Ihr Telefon gesendet',
  'SPECIFIC POWER': 'SPEZIFISCHE LEISTUNG',
  SPECIFIC_POWER: 'Spezifische Leistung',
  SPILL_VALVE_HIGH_PRESSURE: 'Überlaufventil Hochdruck',
  SPILL_VALVE_HP_LOW_LIMIT_SETPOINT: 'Überlaufventil HP Unterer Grenzwert-Sollwert',
  SPILL_VALVE_LOW_PRESSURE: 'Überlaufventil Niederdruck',
  SPILL_VALVE_LP_TARGET_SETPOINT: 'Überlaufventil LP Ziel-Sollwert',
  SSOLoginNotEnabled:
    'Ihre Organisation hat die SSO-Anmeldung für Ihre E-Mail-Adresse nicht aktiviert. Bitte verwenden Sie stattdessen die Kennwortauthentifizierungsmethode.',
  START: 'START',
  START_TEST: 'Test starten',
  STATION_DEGRADATION: 'Stationsverschlechterung',
  STOP: 'STOPP',
  STOPPED: 'Gestoppt',
  SUBMIT_CONFIRMATION_MESSAGE:
    'Mit der Übermittlung des Prüfberichts geben Sie an, dass die Installation abgeschlossen und zur Überprüfung bereit ist.',
  SUBMIT_REPORT: 'Abwesenheitsbericht',
  SYSTEM_AVAILABILITY: 'Systemverfügbarkeit',
  'Salesforce account ID': 'Salesforce-Konto-ID',
  'Save Changes': 'Speichern von Änderungen',
  'Save and activate to start monitoring the parameter and trigger alerts according to the rule.':
    'Speichern und aktivieren, um mit der Überwachung des Parameters zu beginnen und Warnungen gemäß der Regel auszulösen.',
  'Save changes': 'Speichern von Änderungen',
  'Save reason': 'Grund speichern',
  'Saving...': 'Sparen.',
  'Scheduling Issues': 'Probleme bei der Terminplanung',
  Search: 'Suchen',
  Select: 'Wählen Sie',
  'Select All': 'Alle auswählen',
  'Select Controller': 'Controller auswählen',
  'Select Model': 'Modell auswählen',
  'Select Type': 'Typ auswählen',
  'Select User': 'Benutzer auswählen',
  'Select available compressors': 'Verfügbare Kompressoren auswählen',
  'Select manufacturer': 'Hersteller auswählen',
  'Select measurement system': 'Messsystem auswählen',
  'Select role': 'Rolle auswählen',
  'Select station': 'Sender auswählen',
  SelectReason: 'Wählen Sie einen Grund',
  'Send Again': 'Erneut senden',
  'Sensor Based': 'Sensorbasiert',
  'Sensor based': 'Sensorbasiert',
  "Sensors' Issues": 'Probleme mit Sensoren',
  Sep: 'Sep',
  'Serial number': 'Seriennummer',
  Service: 'Dienst',
  'Set point': 'Sollwert',
  Severity: 'Schwere',
  'Shipping Delay': 'Versandverzögerung',
  'Show me (from-to)': 'Zeige mir (von-bis)',
  Shutdown: 'Abschalten',
  'Sign in': 'Anmelden',
  'Sign in with Single Sign On': 'Mit Einmaliges Anmelden (Single Sign On) anmelden',
  'Sign in without Single Sign On': 'Anmeldung ohne Single Sign On',
  'Site configuration data may not be properly saved':
    'Standortkonfigurationsdaten werden möglicherweise nicht richtig gespeichert',
  'Something went wrong': 'Etwas ist schief gelaufen',
  'Something went wrong. Make sure you generated a valid report in the investigation tab':
    'Etwas ist schiefgelaufen. Stellen Sie sicher, dass Sie auf der Registerkarte "Untersuchung" einen gültigen Bericht erstellt haben',
  Source: 'Quelle',
  'Spec data': 'Spezifikationsdaten',
  'Specific Power': 'Spezifische Leistung',
  'Specific Power Baseline': 'Spezifische Leistung Baseline',
  'Specific power': 'Spezifische Leistung',
  'Stage blocked successfully': 'Stufe erfolgreich blockiert',
  Staging: 'Aufführung',
  Start: 'Start',
  'Start Date': 'Datum des Beginns',
  'Start by adding the Salesforce account ID then follow these 3 simple steps':
    'Fügen Sie zunächst die Salesforce-Konto-ID hinzu und folgen Sie dann diesen 3 einfachen Schritten',
  Starting: 'Startet...',
  State: 'Staat',
  Station: 'Bahnhof',
  'Station Control Center': 'Steuerzentrale',
  'Station Draft': 'Station Draft',
  'Station KPIs': 'Station KPIs',
  'Station Switch': 'Station Switch',
  'Station risk degradation tooltip text':
    'Betriebsmäßige Verschlechterung des Systems und der einzelnen Kompressoren gegenüber der Nennspezifikation',
  'Station tracker': 'Stationstracker',
  StationStatus_Inactive: 'Dynamischer Controller ist inaktiv',
  StationStatus_notControlled: 'Nicht gesteuert',
  StationStatus_oneDotFiveActive: 'Dynamische Steuerung 1.5 ist aktiviert',
  StationStatus_oneDotFiveActiveFallback: 'Dynamische Steuerung 1.5 ist aktiviert',
  StationStatus_oneDotFiveDisabled: 'Dynamische Steuerung 1.5 ist deaktiviert',
  StationStatus_oneDotFiveUnderMaintenance: 'Dynamische Steuerung 1.5 ist deaktiviert - unter Wartung',
  StationStatus_oneDotZeroActive: 'Dynamischer Steuerung 1.0 ist aktiviert',
  StationStatus_oneDotZeroDisabled: 'Dynamische Steuerung 1.0 ist deaktiviert',
  StationStatus_oneDotZeroUnderMaintenance: 'Dynamische Steuerung 1.0 ist deaktiviert - unter Wartung',
  StationStatus_offline: 'Offline',
  Status: 'Status',
  Stop: 'Stopp',
  Stopping: 'Stoppt...',
  'Street address': 'Straße und Hausnummer',
  Subscription: 'Abonnement',
  SubscriptionNoControl: 'Abonnement Keine Steuerung',
  'System Degradation': 'Systemverschlechterung',
  'System Health': 'Systemzustand',
  'System Single Point of Failure Risk': 'Risiko eines einzelnen Systemausfallpunkts',
  'System controller type (If installed)': 'Systemsteuerungstyp (falls installiert)',
  TARGET: 'ZIEL',
  TEMPERATURE: 'Temperatur',
  TESTED_BY: 'Getestet von:',
  TESTING: 'Prüfung',
  TESTING_IN_PROGRESS: 'Tests in Arbeit {{time}}',
  TEST_AGAIN: 'Erneuter Test',
  TEST_DATE: 'Test date: {{date}}',
  TEST_DATE_WITHOUT_FIELD: 'Datum der Prüfung:',
  TEST_NOT_INITIATED_DESC: 'Test wurde nicht ordnungsgemäß gestartet. Bitte starten Sie den Test erneut.',
  TEST_NOT_INITIATED_TITLE: 'Test wurde nicht ordnungsgemäß eingeleitet',
  TEST_SUCCESS_DESC: 'Alle Kompressoren haben den Test erfolgreich bestanden.',
  TEST_SUCCESS_TITLE: 'Test erfolgreich abgeschlossen',
  Tabular: 'Tabellarisch',
  'Tanks in the room': 'Tanks im Raum',
  Target: 'Ziel',
  'Target Setpoint': 'Ziel-Sollwert',
  'Target value': 'Sollwert',
  Temperature: 'Temperatur',
  'The logic triggering alerts': 'Die Logik, die Warnungen auslöst',
  'This address will be used for the shipment of equipment': 'Diese Adresse wird für den Versand der Geräte verwendet',
  'This alert record was triggered while the compressor was In-Maintenance':
    'Dieser Alarmdatensatz wurde ausgelöst, während der Kompressor in der Wartung war',
  'This alert rule has been deleted': 'Diese Warnregel wurde gelöscht',
  'This alert rule has changed since the record you clicked on. The last change was on':
    'Diese Warnregel hat sich seit dem Datensatz, auf den Sie geklickt haben, geändert. Die letzte Änderung war am',
  'This feature is currently disabled.': 'Diese Funktion ist derzeit deaktiviert.',
  'This file will be downloaded as a .csv': 'Diese Datei wird als .csv heruntergeladen',
  'This number is already in use': 'Diese Nummer ist bereits in Gebrauch',
  'Time left to complete': 'Verbleibende Zeit bis zur Fertigstellung',
  'Time period': 'Zeitraum',
  'Time presentation interval': 'Zeitdarstellungsintervall',
  'Time to complete': 'Zeit bis zur Fertigstellung',
  'Time zone': 'Zeitraum',
  To: 'An',
  'To modify please contact your system administrator or the Ecoplant support':
    'Zum Ändern wenden Sie sich bitte an Ihren Systemadministrator oder den Ecoplant-Support',
  Trends: 'Trends',
  'Turn compressor off verification': 'Sie sind im Begriff, {{name}} auszuschalten. Sind Sie sicher?',
  'Turn compressor on verification': 'Sie sind dabei, {{name} einzuschalten.} Sind Sie sicher?',
  Type: 'Typ',
  UNLOAD: 'Entladen',
  UNLOAD_TEST: 'Entlastungsprüfung',
  UNRESOLVED_COMPRESSORS_DESC:
    '{{count} Kompressoren haben den Test nicht bestanden. Bitte geben Sie vor dem Absenden des Berichts einen Kommentar oder eine Begründung für jeden Kompressor an',
  UNRESOLVED_COMPRESSORS_MESSAGE:
    'Kompressoren haben den Test nicht bestanden. Bitte geben Sie vor dem Absenden des Berichts einen Kommentar oder eine Begründung für jeden einzelnen Fall an',
  UNRESOLVED_COMPRESSORS_TITLE: 'Ungelöste Kompressorzustände',
  'URL to compressor model spec': 'URL zur Kompressormodellspezifikation',
  UTC: 'UTC',
  'Unarchive Alert': 'Warnung dearchivieren',
  'Unarchive alert failed': 'Dearchivierungswarnung fehlgeschlagen',
  Unavailable: 'Nicht verfügbar',
  Unblock: 'Entsperren',
  'Unblock stage': 'Stufe entsperren',
  'Unit system': 'Einheitensystem',
  'Units are in bar, do you want to continue?': 'Einheiten sind in bar, möchten Sie fortfahren?',
  Unknown: 'Unbekannt',
  Unload: 'Entladen',
  Unloading: 'Wird entladen',
  Unselect: 'Abwählen',
  Update: 'Aktualisieren',
  'Update a custom rule': 'Eine benutzerdefinierte Regel aktualisieren',
  'Update manufacturer alert rule': 'Herstellerwarnregel aktualisieren',
  User: 'Benutzer',
  'User created successfully': 'Benutzer erfolgreich erstellt',
  'User creation failed, please contact support for further information':
    'Benutzererstellung fehlgeschlagen. Weitere Informationen erhalten Sie vom Support',
  'User deleted successfully': 'Benutzer erfolgreich gelöscht',
  'User deletion failed': 'Benutzerlöschung fehlgeschlagen',
  'User must be assigned to at least one station': 'Benutzer muss mindestens einer Station zugewiesen sein',
  'User update failed': 'Benutzeraktualisierung fehlgeschlagen',
  'User updated successfully': 'Benutzer erfolgreich aktualisiert',
  'Users Management': 'Benutzerverwaltung',
  VALUE: 'Wert',
  VIEW_COMMENT: 'Kommentar anzeigen',
  VS: 'VS',
  VSD_TARGET: 'VSD Ziel',
  'Valid values': 'Gültige Werte',
  Validation: 'Validierung',
  'Value may depend on multiple sensors and average values over time.':
    'Der Wert kann von mehreren Sensoren und Durchschnittswerten über die Zeit abhängen.',
  'Value may depend on multiple sensors.': 'Der Wert kann von mehreren Sensoren abhängen.',
  Valve: 'Ventil',
  'Valve - Disconnected': 'Ventil – Ausgeschaltet',
  'Valve state not found': 'Ventilstatus nicht gefunden',
  "View Alert record's rule (logic)": 'Regel (Logik) des Alarmdatensatzes anzeigen',
  Volume: 'Band',
  WATER_FLOW: 'Wasserdurchfluss',
  WATER_PRESSURE_DELTA: 'Wasserdruck Delta',
  WATER_PRESSURE_IN: 'Wasserdruck ein',
  WATER_PRESSURE_OUT: 'Wasserdruck aus',
  WATER_TEMPERATURE: 'Wassertemperatur',
  WORKING_HOURS: 'Arbeitsstunden',
  'Waiting For Deliver': 'Warten auf die Auslieferung',
  'Waiting for equipment': 'Warten auf die Ausrüstung',
  'Waiting for state to change.': 'Ich warte darauf, dass sich der Zustand ändert.',
  Warning: 'Warnung',
  'Water Flow': 'Wasserdurchfluss',
  'Water Temperature': 'Wassertemperatur',
  'Water Temperature In': 'Wassertemperatur Ein',
  'Water Temperature Out': 'Wassertemperatur Aus',
  Weekly: 'Wöchentlich',
  'Welcome to EcoPlant': 'Willkommen bei EcoPlant',
  'Welcome to the site survey': 'Welcome to the site survey',
  Wet: 'Nass',
  'Wet Air Tank': 'Nasslufttank',
  'What is the pressure at this station?': 'Wie hoch ist der Druck an dieser Station?',
  'When comparing 2 time periods, you can choose up to 5 parameters.':
    'Beim Vergleich von 2 Zeiträumen können Sie bis zu 5 Parameter auswählen.',
  'While your file is being prepared do not refresh or close this tab':
    'Während Ihre Datei vorbereitet wird, aktualisieren oder schließen Sie diese Registerkarte nicht',
  YEAR: 'JAHR',
  'YEAR TOTAL': 'JAHR INSGESAMT',
  YTD: 'YTD',
  'Yearly View': 'Jährliche Ansicht',
  Yes: 'Ja',
  Yesterday: 'Gestern',
  'You are about to delete this user completely. Are you sure?':
    'Sie sind dabei, diesen Benutzer vollständig zu löschen. Sind Sie sicher?',
  'You are about to modify the control of the dynamic controller. Are you sure?':
    'Sie sind dabei, die Steuerung des dynamischen Reglers zu ändern. Sind Sie sicher?',
  'You are about to remove this user’s access to this station. Are you sure?':
    'Sie sind dabei, diesem Benutzer den Zugang zu dieser Station zu entziehen. Sind Sie sicher?',
  'You are not allowed to change power state for devices.':
    'Sie dürfen den Stromversorgungszustand von Geräten nicht ändern.',
  'You can choose up to 10 parameters per time period. When comparing 2 time periods, you can choose up to 5 parameters.':
    'Sie können bis zu 10 Parameter pro Zeitraum auswählen. Beim Vergleich von 2 Zeiträumen können Sie bis zu 5 Parameter auswählen.',
  'You can only turn this alert rule off.': 'Sie können diese Warnregel nur deaktivieren.',
  'You dont have enough permission to create an alert, please contact your administrator.':
    'Sie verfügen nicht über die erforderliche Berechtigung zum Erstellen einer Warnung. Wenden Sie sich bitte an Ihren Administrator',
  'ZIP code': 'Postleitzahl',
  '_ _': '_ _',
  accountPlaceholder: 'Salesforce-Konto-ID hinzufügen',
  accountRequired: 'Salesforce-Konto-ID eingeben',
  accountTooltip: 'ID_18 aus Salesforce Hinzufügen',
  actionTaken: 'Ergriffene Maßnahmen',
  wasted: 'Verschwendet',
  actions: 'Aktionen',
  actionsPending: 'Anhängige Aktionen',
  actionsTaken: 'Ergriffene Maßnahmen',
  activate: 'Aktivieren Sie',
  activateDynamicController: 'Dynamischen Controller aktivieren',
  activateDynamicControllerMessage: 'Wirklich Sie die dynamische Steuerung aktivieren wollen?',
  active: 'Aktiv',
  activeAsset: 'Für diese Anlage aktiviert ist',
  activity: 'Aktivität',
  actualValue: '(Tatsächlicher Wert)',
  add: 'Hinzufügen',
  setAnAudit: 'Überprüfungszeitraum festlegen',
  addCompressor: 'Um einen Kompressor hinzuzufügen',
  addCompressorGroup: 'Neue Kompressorgruppe hinzufügen',
  addFallback: 'Hinzufügen Fallback',
  addIndividualSensors: 'Und fügen Sie einzelne Sensoren hinzu, um auf den Betriebszustand Ihres Systems zuzugreifen',
  addLevel: 'Hinzufügen Level',
  addNextPeriodicShutdown: 'Entwurf der nächsten Leckageperiode hinzufügen',
  addOns: 'Hinzufügen-Ons',
  addPressureRange: 'Hinzufügen Druckbereich',
  addPressureSensorPack: 'Und fügen Sie ein Drucksensorpaket hinzu, um den Systemdruck und die Leckage zu ermitteln.',
  addRangeName: 'Hinzufügen Bereichsname',
  addScenario: 'Hinzufügen Szenario',
  addStation: 'Hinzufügen Bahnhof',
  addStationKpis:
    'Und erhalten Sie Ihre vollständigen Bahnhofs-KPIs, Klicken Sie hier und aktivieren Sie die Systemansicht',
  addUpperRange: 'Hinzufügen oberer Bereich',
  additionalSensors: 'Zusätzliche Sensoren',
  advancedInfo: 'Advanced info',
  advancedSettings: 'Erweiterte Einstellungen',
  aerationBasin: 'Belüftungsbecken',
  'air-expert-installation-approval': 'Genehmigung der Installation durch einen Luftexperten',
  airCooled: 'Luftgekühlt',
  airFilter: '$t(Filter)',
  airTemperatureSensor: '$t(LUFT_TEMPERATUR_SENSOR)',
  alert: 'Alarmierung',
  algo: 'Algo',
  all: 'Alle',
  allAssetViewFeatures: 'Alle KNOW - ASSET Merkmale, plus:',
  allSimpleControlFeatures: 'Alle CONTROL-Merkmale, plus:',
  allSystemViewFeatures: 'Alle KNOW - SYSTEM Merkmale, plus:',
  allocateStationDescription: 'Diese Station einem bestehenden Ecoplant-Konto zuordnen?',
  allowCookies: 'Cookies erlauben',
  alpha: 'Alpha',
  alwaysPerform: 'Und arbeiten dank der automatischen Systemsteuerung immer im optimalen Betriebsmodus',
  ambientHumiditySensor_ambientTemperatureSensor: 'Umgebungs Feuchtigkeit- und Temperatur Sensor',
  ambientHumiditySensor_ambientTemperatureSensor_dewpointSensor:
    'Umgebungsfeuchtigkeits-, Temperatur- und Taupunktsensor',
  ammoniaAmmonium: 'Ammoniak (NH3)/Ammonium (NH4+)',
  ammoniaAmmoniumSensor: '$t(AmmoniakAmmonium) Sensor',
  and: 'Und',
  annugalHoursCoverage: 'Jährliche Stundenzahl Abdeckung',
  any: 'Jede',
  approvalReport: 'Genehmigungsbericht',
  'approve-pid': 'PID genehmigen',
  'archive alert failed': 'Archivierungswarnung fehlgeschlagen',
  asset: 'Vermögen',
  assetCount: '{{assetCount}} Kompressoren',
  assetImages: 'Asset-Bilder',
  assetInfo: 'Asset-Informationen',
  'assign-cs-owner': 'Eigentümer des Kundenerfolgs',
  'assign-engine-owner': 'Eigentümer des Motors',
  associateWithCustomer: 'Verbinden Sie sich mit einem Ecoplant-Kunden (optional)',
  aut: 'AUT',
  autoStop: 'Automatischer Stopp',
  'available delta decrease part1':
    'Ihre Produktionskapazität im Vergleich zum Vormonat spiegelt eine gesunkene Leistung von wider.',
  'available delta decrease part2': '. Überprüfen Sie Ihre Kompressoren auf Wartung und Funktionsbeeinträchtigungen.',
  availableSitesForm: 'Verfügbare Standortgutachten',
  average: 'Durchschnitt',
  back: 'Zurück',
  'back indication': 'Zurückanzeige',
  backButton: 'Zurück',
  backgroundData: 'Hintergrunddaten sind Beispiele',
  backgroundDataLeakage: 'Hintergrunddaten sind Beispiele für das Leakage-Widget.',
  backgroundDataMap: 'P&ID im Hintergrund stellt ein Beispiel für die System Map dar',
  backgroundDataSystemHealth: 'Hintergrunddaten sind Beispiele für das System Health Widget.',
  backgroundDataYearlyView:
    'Hintergrunddaten sind Beispiele für die jährliche Energiebilanz einschließlich Einsparungen.',
  bandConfiguration: 'Band-Konfiguration',
  bar: 'Bar',
  'baseline-period': 'Basiszeitraum',
  'baseline-report': 'Bericht über die Ausgangssituation',
  baselineSetpoints: 'Basissollwerte',
  beta: 'Beta',
  billedAnnually: 'Jährlich abgerechnet oder',
  blockStageModalDescription:
    'Helfen Sie dem Team zu verstehen, was die Dinge verzögert, damit wir schnell handeln können.',
  blockStageModalReason: 'Grund für die Sperrung',
  blockStageModalTitle: 'Warum blockieren Sie diese Phase?',
  blower: 'Gebläse',
  blowerSpeed: 'Gebläsedrehzahl % (RPM)',
  bnd: 'BND',
  bookAService: 'Dienstleistung buchen',
  booster: '$t(Booster)',
  bovMax: 'BOV-Schwellenwert zur Entlastung bei der Prüfung',
  bovMin: 'Minimaler durchschnittlicher BOV für den Entlastungstest',
  bypassValve: 'Umgehungsventil',
  calculatedValues: 'Berechnete Werte',
  canContinueEditing:
    'Sie können sie weiter bearbeiten oder eine neue Umfrage starten. Wenn Sie eine neue Umfrage starten, wird die bestehende ersetzt und kann nicht rückgängig gemacht werden.',
  cancel: 'Abbrechen',
  cancel_button_content:
    'Sie sind im Begriff, den Validierungsprozess der Installation abzubrechen. Alle erfassten Daten werden verworfen und nicht gespeichert. Sind Sie sicher, dass Sie den Vorgang abbrechen möchten?',
  cancel_validation_test: 'Abbrechen Validierungstest?',
  capacity: 'Kapazität',
  care: 'CARE',
  careAgrremntID: 'ID der Vereinbarung',
  careServiceSignUp: 'Anmeldung zum CARE-Serviceplan',
  causeCommentLengthError: 'Kommentar zur möglichen Ursache muss zwischen 2 und 200 Zeichen lang sein.',
  celsius: 'Celsius',
  centrifugal: 'Zentrifugal Kompressor',
  centrifugalStation1_0Notification:
    'Sie bearbeiten Engine 1.5, aber Engine 1.0 ist aktiv. Die Änderungen werden erst wirksam, wenn Engine 1.5 in Retool aktiviert wird.',
  centrifugal_powerSensor: '$t(zentrifugal)',
  cfm: 'Cfm',
  changes: 'Änderungen',
  changesInMainRangesAffectFallbackRules:
    'Änderungen in den Hauptbereichen führten zu Änderungen in den Ausweichregeln. Sind Sie sicher, dass Sie fortfahren wollen?',
  chooseRule: 'Regel wählen',
  clear: 'Klar',
  clickHere: 'Hier klicken',
  closeButton: 'Schließen',
  closeModalBody:
    'Ihr Fortschritt wurde gespeichert. Sie können die Bearbeitung dieses Senders jederzeit in der Senderliste auf dem Hauptbildschirm fortsetzen.',
  comment: 'Kommentar',
  commentLengthError: 'Kommentar muss zwischen 2 und 200 Zeichen lang sein.',
  comments: 'Kommentare:',
  commentsInfo: 'Kommentare werden nur im eingereichten Bericht gespeichert.',
  compareTwoTimePeriods: '2 Zeiträume vergleichen',
  compatible: 'Kompatibel',
  compressor: 'Kompressor',
  compressorGroups: 'Kompressor-Gruppen',
  compressorIsNotCompatibleToGroup:
    'Alle Kompressoren, die zu Gruppen hinzugefügt werden, müssen die gleichen Aktionen haben',
  compressorMetrics: 'Kompressor-Metriken',
  compressorParameters: 'Kompressor-Parameter',
  compressorParametersMissing: 'Einige der Kompressorparameter fehlen',
  compressorRapidCycling: 'Kompressor Schnelles Zyklieren',
  compressorRooms: 'Kompressorräume',
  compressorType: 'Kompressor-Typ',
  compressors: 'Kompressoren',
  compressorsAdded: 'Kompressoren hinzugefügt:',
  compressorPriorityChangedToIgnore: 'Die Kompressorpriorität wurde von (Aktiv/Backup) auf Ignorieren geändert:',
  compressorPriorityChangedFromIgnore: 'Die Kompressorpriorität wurde von Ignorieren auf (Aktiv/Backup) geändert:',
  compressorsAreMandatory: 'Kompressoren sind obligatorisch',
  compressorsCombinationMustBeUnique: 'Kombination der Kompressoren muss eindeutig sein',
  compressorsFallback: 'Kompressoren Fallback',
  compressorsGroupOrder: 'Kompressoren Gruppenauftrag',
  compressorsMustHaveSameHp: 'Kompressoren müssen die gleiche Leistung haben',
  compressorsRemoved: 'Entfernte Kompressoren:',
  confirmCustomerDetails: 'Kundendaten bestätigen',
  confirmDeactivationButtonText: 'Deaktivierung bestätigen',
  confirmDeactivationTitle: 'Bestätigung der Deaktivierung und Angabe des Grundes',
  confirmDeleting: 'Periodenabschaltung für Perioden {{period}} löschen',
  confirmPublish: 'Bestätigen von Verlagsänderungen',
  confirmStop: 'Stopp bestätigen',
  confirmStopDescription: 'Sie sind dabei, diesen Kompressor zu stoppen. Bestätigen Sie, um fortzufahren.',
  confirmSubmission: 'Vorlage Bestätigen',
  connected: 'Verbunden',
  connectivity: 'Konnektivität',
  contactCustomerSuccessManager: 'Wenden Sie sich an Ihren Kundenbetreungs Manager, um dieses Verhalten zu ändern.',
  contactPerson: 'Kontaktperson',
  continue: 'Weiter',
  continueEditingForm: 'Weitere Bearbeitung',
  continue_test: 'Weiterer Test',
  continuousAutiding: 'Kontinuierliche Prüfung',
  'control mode': 'Steuermodus',
  coolingType: 'Art der Kühlung',
  "couldn't fetch data": 'Daten konnten nicht abgerufen werden',
  createNewDraft: 'Neuen Entwurfs Erstellen',
  createNewSite: 'Site Survey erstellen oder bearbeiten',
  createdOn: 'Erstellt am:',
  current: 'Strom',
  customRule: 'Benutzerdefinierte Regel',
  customSetpoints: 'Benutzerdefinierte Sollwerte',
  customerInformationStepLabel: 'Bestätigen Kundeninfo',
  cycle: 'Zyklus',
  dailyFlowTooltip: 'Täglicher Durchschnittsdurchfluss des Vormonats',
  dark: 'Dunkelheit',
  dateCompleted: 'Datum der Fertigstellung',
  dateOpened: 'Datum Eröffnet',
  dateTime: 'Datum und Uhrzeit:',
  day: 'Tag',
  dayChar: 'D',
  de: 'Deutsch',
  deactivatedBy: 'Deaktiviert von:',
  deactivationContent:
    'Deaktivierung des dynamischen Controllers kann den Systembetrieb beeinträchtigen. Bitte bestätigen Sie und teilen Sie den Grund für die Deaktivierung mit',
  deactivationReason: 'Grund der Deaktivierung',
  decline: 'Ablehnen',
  'default state': 'Standardstatus',
  defaultBehaviour: 'Standardverhalten',
  defaultRule: 'Standard-Regel',
  defaultSetpoints: 'Tabelle Standardwerte',
  defaultSetpointsConfiguration: 'Tabelle Standardwerte',
  defaultSetpointsInfoMessage:
    'Sollwerte basieren auf dem gemessenen Leitungsdruck des Kompressors (Druckabfall berücksichtigen)',
  defaults: 'Standardeinstellungen',
  delete: 'Löschen',
  deleteImage: 'Sind Sie sicher, dass Sie dieses Bild löschen möchten? Diese Aktion ist nicht rückgängig zu machen.',
  deletePopconfirmTitle: 'Sie sind dabei, {{item}} zu löschen. Sind Sie sicher?',
  derivedSystemEfficiencyParameters: 'Abgeleitete Parameter für die Systemeffizienz',
  desiccantAirDryer: '$t(Trockenmittel-Lufttrockner)',
  german: 'Deutsch',
  deviceAttributes: 'Geräteattribute',
  devicesStatus: 'Gerätestatus',
  'dew point': 'Taupunkt',
  'dew point temperature': 'Taupunkttemperatur',
  dewpointSensor: '$t(Taupunktsensor)',
  dewpointSensor_pressureSensor: 'Taupunkt und Druck Sensor',
  discard: 'Ja (verwerfen)',
  discardAndExit: 'Verwerfen & Beenden',
  disconnected: 'Abgeschaltet',
  dissolvedOxygen: 'Gelöster Sauerstoff',
  dissolvedOxygenSensor: '(gelösterSauerstoff) Sensor',
  draft: 'Entwurf',
  draftPublishedOn: 'Entwurf veröffentlicht am',
  draftSaved: 'Entwurf erfolgreich gespeichert',
  draftSavedDesc: 'Ihre Änderungen werden gespeichert. Denken Sie daran, sie zu veröffentlichen, wenn Sie fertig sind.',
  draftVersionText: 'Und die bestehende Entwurfsversion {{draftVersion}} außer Kraft setzen',
  dryAirTank: '$t(Trockenluftbehälter)',
  drying: 'Trocknen',
  dynamicControl: 'Dynamische Steuerung',
  dynamicControlDescription:
    'Schalten Sie die vollständige dynamische Steuerung frei, um den Betrieb automatisch zu analysieren und an die Produktionsanforderungen anzupassen und so eine maximale Systemeffizienz zu erzielen. Darüber hinaus können Sie Luftlecks erkennen und isolieren, um die Effizienz noch weiter zu verbessern und Ihre Gesamtenergiekosten auf ein Minimum zu reduzieren.',
  dynamicControlEngine: 'Dynamische Steuerungs-Engine',
  ecoplantOffering: 'Ecoplant-Angebot',
  edgecasenotproperlycovered: 'Randfälle sind nicht ordnungsgemäß abgedeckt',
  edit: 'Bearbeiten',
  editMode: 'Bearbeitungsmodus',
  editScenarios: 'Szenarien bearbeiten',
  effective: 'Wirksam',
  emergencyStartFrequency: 'Frequenz des Notstarts',
  en: 'Englisch',
  enableSystemControl: 'Systemsteuerung aktivieren',
  energySaving: 'Energie einsparen',
  energySavingsOpportunity: 'Gelegenheit zur Energieeinsparung',
  energySavingsReportDescription:
    'Nachfolgend finden Sie die Energieeinsparungen, die durch den Ecoplant Dynamic Controller erzielt wurden. Es wird in verschiedenen Zeitauflösungen dargestellt: Vortag, Monat bis Datum, Jahr bis Datum und Lebenslange Ersparnisse. Es wird in (1) Prozent (%) (und in kWh) (2) in Landeswährung (3) angegeben. Geschätzte metrische Tonnen der Treibhausgasreduzierung. Die Einsparungen werden auf der Grundlage eines Vergleichs mit dem Basiszeitraum und den erfassten Ergebnissen berechnet. spezifische Leistung (S/P).',
  energySavingsReportTitle: 'Ecoplant 360-Bericht',
  energySavingsSystemTierTooltipPart1:
    'Erwartete Energieeinsparmöglichkeiten auf der Grundlage realer Fallstudien. Um immer in einem optimalen Betriebsmodus zu arbeiten und diese Einsparungen zu erzielen,',
  energySavingsSystemTierTooltipPart2: 'Und fügen Sie Systemsteuerung hinzu',
  energySavingsWidget: 'Widget zum Energiesparen',
  'engine-activation-date': 'Datum der Aktivierung des Motors',
  engineValidationMessage:
    'Sie können die Station nicht aus dem Abonnementstatus verschieben, solange der Motorstatus aktiv ist. Bitte stellen Sie sicher, dass Sie den Motor deaktivieren, bevor Sie den Stationsstatus ändern.',
  engineValidationTitle: 'Motorstatusvalidierung',
  english: 'Englisch',
  equalTo: 'Gleich zu',
  error: 'Fehler',
  errorDraftPublish: 'Fehler beim Veröffentlichen des Entwurfs',
  errorDraftPublishDesc: 'Es ist ein Fehler bei der Veröffentlichung Ihrer Änderungen aufgetreten.',
  errorRevertLastPublished: 'Fehler beim Zurückkehren zur letzten Veröffentlichung',
  errorRevertLastPublishedDesc: 'Es ist ein Fehler aufgetreten, der zur letzten veröffentlichten Version zurückführt.',
  errorSavingChanges: 'Es ist ein Fehler beim Speichern Ihrer Änderungen aufgetreten.',
  errorSavingDraft: 'Fehler beim Speichern des Entwurfs',
  errorSavingDraftdesc:
    'Füllen Sie alle erforderlichen Felder sowohl für die Station als auch für die Kompressoren aus.',
  errorSavingEngineConfig: 'Fehler beim Speichern der Motorkonfiguration. Bitte versuchen Sie es später noch einmal.',
  es: 'Spanisch',
  estimatedDeliveredValue: 'Geschätzter gelieferter Wert',
  estimatedLeakTooltip: 'Geschätztes Leck ({{estimatedLeak}}',
  events: 'Veranstaltungen',
  excludeFuturePeriodicShutdowns: 'Zukünftige Stillstandszeiten ausschließen',
  expandYourStation:
    'Erweitern Sie Ihre Station und verschaffen Sie sich einen umfassenden Überblick über alle relevanten Komponenten',
  expectedAnnualSavings: 'Erwartete jährliche Einsparungen',
  expectedROI: 'Erwarteter ROI',
  expirationDate: 'Verfallsdatum',
  externalDeviceId: 'Externe ID',
  extremeUsecasesAreNotProperlyCovered: 'Extreme Anwendungsfälle sind nicht angemessen abgedeckt',
  fahrenheit: 'Fahrenheit',
  fallback: 'Fallback {{priority}}',
  fallbackOverview: 'Fallback',
  fallbackScenarios: 'AUSWEICHSZENARIEN',
  fallbackcoverage: 'Rückfalldeckung',
  fallbacks: 'Fallbacks',
  false: 'Falsch',
  'filter type': 'Filtertyp',
  finish: 'Oberfläche',
  fiveLoop: '5 Schleife',
  fixedSpeed: 'Kompressor mit fester Drehzahl',
  fixedSpeed_powerSensor: '$t(festeGeschwindigkeit)',
  flow: 'Durchfluss',
  flowIsCalculated: 'Durchfluss wird berechnet',
  flowKPIModified: 'Fluss-KPI geändert:',
  flowLabel: 'Durchfluss',
  flowLevel: 'Durchflussmenge',
  flowLevels: 'DURCHFLUSSPUNKTE',
  flowLevelsChanged:
    'Sensorwertebereiche werden geändert, die Rechenregelwerte entsprechend geändert und die neuen Werte gespeichert',
  flowPeakBuffer: 'Durchfluss-Spitzenwert-Puffer',
  flowRanges: 'Durchflussbereiche',
  flowSensor: '$t(Durchflusssensor)',
  flowSensorKPI: 'Durchflusssensor KPI',
  flowSensor_pressureSensor: 'Durchfluss und Druck Sensor',
  flowSensorsFallback: 'Durchflusssensoren Fallback',
  flowSensorsPriority: 'AUSWAHL DER DURCHFLUSSSENSOREN',
  flowSensorsSelection: 'Auswahl der Durchflusssensoren',
  flowTestFailed: 'Durchflusstest fehlgeschlagen',
  flowTestNotTested: 'Durchflussprüfung nicht durchgeführt',
  flowlevels: 'Durchflussmengen',
  forDetectingAndIsolating: 'Zur Erkennung und Eingrenzung von Leckagen reduziert Ihre Energieverluste erheblich.',
  forMoreThan: 'Für mehr als',
  fr: 'Französisch',
  french: 'Französisch',
  frequency: 'Frequenz',
  'ft^3': 'Ft<0>3</0>',
  fullLoadPressureBuffer: 'Volllast-Druckpuffer',
  unloadTestingFlowBufferPercentage: 'Prozentsatz des Entlade-Test-Durchflusspuffers',
  gallon: 'Gallone',
  general: 'Allgemein',
  getSensorPackage: 'Und hol dir das richtige Sensorpaket.',
  getYourPrice: 'Erhalten Sie Ihren Preis',
  greaterThan: 'Größer als',
  greaterThanOrEqualTo: 'Größer als oder gleich zu',
  greenhouseGasEmission: 'Emission von Treibhausgasen',
  groupAndPriority: 'Gruppe | Priorität',
  h: 'H',
  high: 'Hoch',
  higherUpperBound: 'Muss höher sein als die vorherige Obergrenze',
  hour: 'Stunde',
  hourAverageWithCount: '{{count}} Stundendurchschnitt',
  hourAverageWithCount_plural: '{{count}} Stundendurchschnitt',
  hours: 'Stunden',
  hoursToService: 'Stunden bis zum Dienst',
  hp: 'HP',
  id: 'Id',
  imageUploadFailedMessage: 'Einige Bilder konnten nicht gespeichert werden',
  imageUploadFailedMessageDescription:
    '{{failedCount}} von {{totalCount}} Bildern konnten nicht gespeichert werden. Sie können sie überprüfen und bei Bedarf erneut hinzufügen',
  imm: 'IMM',
  immediateStop: 'Sofortiger Stopp',
  imperial: 'Kaiserlich',
  improveSystemPerformance:
    'Zu Energie, Wartung und Risiko verbessern die Leistung und den Zustand des Systems und senken die Betriebskosten.',
  inactive: 'Inaktiv',
  inch: 'Zoll',
  incompleteCompressorParameters: 'Unvollständige Kompressor-Parameter',
  incompleteStationParameters: 'Unvollständige Stationsparameter',
  individual: 'Einzelne',
  infinity: 'Unendlichkeit',
  influentFlow: 'Zuflussmenge',
  influentFlowSensor: '$t(ZuflussDurchfluss) Sensor',
  inletValve: 'Einlassventil',
  insightName: 'Einsicht Name',
  insights: 'Einblicke',
  insightsReportDescriptionOne:
    'Ecoplant 360 bietet seinen Benutzern fortlaufende Einblicke, die entweder von unserem System oder von unseren Experten generiert werden, die es sich ansehen. das System. Diese Erkenntnisse sind in drei Kategorien unterteilt: Energie, Wartung und Risiko. Alle Erkenntnisse hätten Eine Aktion, die entweder eine ausstehende Aktion oder eine ergriffene Maßnahme anzeigt. Zeigt den entsprechenden geschätzten USD-Betrag an.',
  insightsReportDescriptionThree:
    'Das Abonnement von Live-Insights konnte im Ecoplant 360-Dashboard abgeschlossen werden',
  insightsReportDescriptionTwo:
    'Für jede ausstehende Aktion klicken Sie bitte auf die entsprechende Information, um weitere Maßnahmen zu ergreifen. Für jede Klarstellung und technische Details wenden Sie sich bitte an Ihren Customer Success Manager.',
  'installation-status': 'Status der Installation',
  'installation-validation-date': 'Datum der Validierung der Installation',
  invalidDate: 'Ungültiges Datum',
  is: 'Ist',
  'is Activated': 'Wird aktiviert',
  'is Deactivated': 'Deaktiviert ist',
  'is Disabled - Under Maintenance': 'Ist deaktiviert – wird gewartet',
  'is Disabled by Cloud Control Switch': 'Ist durch Cloud Control Switch deaktiviert',
  'is Disabled by Local Control Switch': 'Ist durch lokalen Steuerschalter deaktiviert',
  isCalculated: '{{metric}} wird berechnet.',
  isPartOf: 'Ist Teil des Value Dashboards, das Ihr System- und Produktionsrisikoniveau in Echtzeit überwacht.',
  kW: 'KW',
  'kW Based Calculation': 'KW-basierte Berechnung',
  'kW Calc. Based': 'KW berechnet Basiert',
  'kW based Calculation': 'KW-basierte Berechnung',
  'kW based calculation': 'KW-basierte Berechnung',
  'kW/(m3/min)': 'KW/(m<0>3</0>/min)',
  'kW/(m^3/min)': 'KW/(m^3/min)',
  'kW/100CFM': 'KW/100CFM',
  kWh: 'KWh',
  'kWh/MG': 'KWh/MG',
  keepEditing: 'Nein (weiter bearbeiten)',
  'kickoff-meeting-date': 'Datum des Kickoff-Meetings',
  kpiIntervalRetrieval: 'KPI-Intervall für den Abruf',
  kwLeakRateSliderTooltip: 'Geschätzter Stromverbrauch beim letzten periodischen Abschalten',
  language: 'Sprache',
  languageUpdateFailed: 'Sprachaktualisierung fehlgeschlagen',
  languageUpdateSuccess: 'Sprache erfolgreich aktualisiert',
  'last command': 'Letzter Befehl',
  'last service': 'Letzte Wartung',
  lastLeakageMeasure: 'Luftleckabschätzung relativ zu {{month}} {{year}}',
  lastMeasureDate: 'Letzte Leckmessung',
  lastUpdated: 'Zuletzt aktualisiert',
  leakFlow: 'Gemessenes Leck',
  leakMeasureFlow: '% Durchfluss',
  leakMeasurement: 'Leckmessung',
  leakMeasurementInDays: 'Leckmessung geplant in {{count}} Tagen',
  leakMeasurementNear: 'Leckmessung in einer Woche',
  leakMeasurementOnGoing: 'Leckmessung ist im Gange',
  leakPeriod: 'Leckperiode',
  leakProductionFlow: '% Prod.-Fluss',
  leakage: 'Durchsickern',
  leakageCreatedNotificationMessage: 'Benachrichtigt, wenn ein neues Leckage-Ereignis erstellt wird',
  leakageReportDescription:
    'Ecoplant 360 bietet seinen Nutzern einen Überblick über die geschätzten Leckagen. Um eine aktuelle Leckageanzeige zu gewährleisten, fügen Sie bitte auf dem Wertedashboard Ihren nächsten erwarteten Produktionsstillstand hinzu. Während des Stillstands und zur Messung der Leckage würde der Kompressor für einige Stunden in Betrieb bleiben, damit das System den Verbrauch durch die Lecks im System messen kann.',
  leakageWidget: 'Leckage-Widget',
  learnMoreAndEnableKPIs:
    'Erfahren Sie mehr & aktivieren Sie KNOW - SYSTEM, um Ihre individuellen Performance KPIs zu erhalten',
  learnMoreAndEnableLeakage: 'Mehr erfahren & Leakage aktivieren',
  learnMoreAndEnableSystemControl: 'Erfahren Sie mehr und aktivieren Sie die Systemsteuerung',
  learnMoreAndEnableSystemHealth: 'Mehr erfahren & Systemgesundheit aktivieren',
  learnMoreAndRequestTrial: 'MEHR ERFAHREN & TESTVERSION ANFORDERN',
  learnMoreAndWatchVideo: 'Mehr erfahren & Video ansehen',
  learnMoreIncreaseSavings: 'Erfahren Sie mehr und erhöhen Sie Ihre Einsparungen mit zusätzlichen Systemeinblicken',
  learnMoreIncreaseSavingsNum:
    'Erfahren Sie mehr und & steigern Sie Ihre Einsparungen mit # {{num}} zusätzlichen Systemeinblicken',
  learnMoreRecord: 'Mehr erfahren und Ihre Leistung genau aufzeichnen',
  lessThan: 'Weniger als',
  lessThanOrEqualTo: 'Weniger als oder gleich zu',
  lifetime: 'LIFETIME',
  lifeTimeLocalization: 'Lifetime',
  lifetimeValue: 'Lifetime Wert',
  light: 'Licht',
  'link-bom-document': 'Station BOM',
  lit: 'Lit',
  liter: 'Liter',
  lo: 'LO',
  load: 'Laden Sie',
  loadBalancingPressureFactor: 'Lastausgleich Druckversatz',
  loadBand1: 'Lastband 1',
  loadBand2: 'Lastband 2',
  loadTestFailed: 'Lasttest fehlgeschlagen',
  loadTestNotTested: 'Lasttest nicht durchgeführt',
  lockedFunctionality: 'Gesperrte Funktionalitäten',
  logic: 'Logik',
  logicPerFlowLevel: 'Logik pro Flow Level',
  low: 'Niedrig',
  lowLimit: 'Untergrenze',
  lowerBoundFlow: 'Unterer Grenzfluss',
  lowerBoundPressure: 'Unterer Grenzwert Druck',
  lp: 'LP',
  'm3/hour': 'M<0>3</0>/hour',
  'm3/min': 'M<0>3</0>/min',
  'm^3': 'M<0>3</0>',
  'm^3/min': 'M^3/min',
  main: 'Hauptseite',
  mainRanges: 'Hauptsortimente',
  mainRangesConfiguration: 'Durchfluss- und Druckkonfiguration',
  mainRangesResult: 'ERGEBNIS',
  maintenance: 'Wartung',
  manual: 'Handbuch',
  maxFlow: 'Maximaler Durchfluss',
  maxLoadAmps: 'Max. Last Ampere',
  maxTarget: 'Maximales Ziel',
  maxTargetGreaterThanMinTarget: 'Max Target sollte größer sein als Min Target',
  maximum: 'Maximum',
  measuredLeak: 'Gemessenes',
  measurementLogTitle: 'Folgenden Daten beziehen sich auf den Zeitraum, in dem das Leck entdeckt wurde.',
  segmentation: 'Segmentierung',
  timeline: 'Zeitachse',
  measurementSystem: 'Maßeinheit',
  medium: 'Mittel',
  'meeting-presentation': 'Meeting Zusammenfassung',
  'meeting-transcript': 'Niederschrift der Sitzung',
  metric: 'Metrisch',
  metrics: 'Metriken',
  'min-pressure': 'Minimaler Druck',
  minCompressorRestartInterval: 'Mindestintervall für den Neustart des Kompressors',
  minCompressorStartInterval: 'Minimales Startintervall des Kompressors',
  minFrequency: 'Verzögerung beim Entladeversuch',
  minIntervalHighFlowTrigger: 'Mindestabstand vom Auslöser des hohen Durchflusses',
  minLoadedCompressors: 'Mindestanzahl der belasteten Kompressoren',
  minPressureSafetyMargin: 'Mindestdruck-Sicherheitsabstand',
  minTarget: 'Min Ziel',
  minTargetLessThanMaxTarget: 'Min Target sollte kleiner sein als Max Target',
  minimum: 'Minimum',
  minute: 'Minute',
  minuteAverageWithCount: '{{count}} Minutendurchschnitt',
  minuteAverageWithCount_plural: '{{count}} Minutendurchschnitt',
  minutes: 'Minuten',
  missingMandatoryFieldValue:
    'Editierbares Feld = "{{field}}" von compressor = "{{compressor}}" aus Tabelle = "{{table}}" erfordert eine gültige Eingabe.',
  missingSpec: 'Fehlende Spezifikation',
  mm: 'Mm',
  mod: 'MOD',
  model: 'Modell',
  modelAttributes: 'Modellattribute',
  modelSpecs: 'Modellspezifikationen',
  modulate: 'Modulieren Sie',
  mon: 'Mon',
  monitorAndSupervise:
    'Um die Leistung Ihres gesamten Systems zu überwachen und kritische Komponenten sofort zu erkennen.',
  month: 'Monat',
  monthly: 'Monatlich',
  moreActions: 'Weitere Aktionen',
  moreDetailsInStationControl: 'Weitere Einzelheiten finden Sie auf der Registerkarte Steuerzentrale',
  moreDetailsInValueDashboard: 'Weitere Details finden Sie in der Wert Instrumententafel Bildschirm',
  moveToMaintenance: 'Zur Wartung verschieben',
  mustBeEqualOrHigherThan1: 'Muss gleich oder größer als 1 sein',
  name: 'Name',
  'new stage:': 'Neue Etappe:',
  newDraft: 'Neuer Entwurf',
  newRecommendedConfiguration:
    'Neue Version des dynamischen Controllers ist verfügbar. Erstellungsdatum: {{createdDate}}',
  newRuleName: 'NEUE REGEL NAME',
  next: 'Weiter',
  nextPeriodicShutdown: 'Weiterer Shutdown',
  nextPeriodicShutdownPopconfirm1:
    'Entwurf für eine Leckperiode wurde erstellt. Er wird hier erst angezeigt, wenn der Ecoplant-Experte ihn genehmigt hat.',
  nextPeriodicShutdownPopconfirm2:
    'Stellen Sie sicher, dass die Kompressoren mindestens 2 Stunden lang eingeschaltet bleiben, damit das System mögliche Lecks auffangen kann.',
  nitrate: 'Nitrat (NO3-)',
  nitrateNO3Sensor: '$t(Nitrat) Sensor',
  nitrite: 'Nitrite (NO2-)',
  nitriteNO2Sensor: '{pH_0}}(Nitrit) Sensor',
  no: 'No',
  noAlertsAtTheMoment: 'Derzeit keine Warnungen',
  noAlertsToShow:
    'Keine Warnungen anzuzeigen. Sie können alte Warnmeldungen unter der Registerkarte <1>Archiv</1> ansehen.',
  noBaseline: 'Keine Basislinie',
  noCarePlan: 'Kein CARE-Plan',
  noCareProgram: 'No Care Programm',
  noDefaultBaselineStrategy: 'Zurzeit ist keine Standard-Basisstrategie verfügbar.',
  noDynamicController: 'Dynamische Controller wurde nicht definiert.',
  noMetricsAvailable: 'Keine Metriken verfügbar',
  noStationsAvailable: 'Keine Stationen verfügbar',
  nocareprogram: 'Kein Paket',
  none: 'Keine',
  noneSetpoints: 'Zuletzt konfigurierte Sollwerte',
  notActive: 'Nicht aktiv',
  notCompatible: 'Nicht kompatibel',
  notEqualTo: 'Nicht gleich zu',
  notSelectedPressureType: 'Druckart noch nicht ausgewählt',
  now: 'Jetzt',
  of: 'Von',
  off: 'Aus',
  offsetFromTargetPressure: 'Totzone vom Zieldruck, in der der Lastausgleich erfolgen soll',
  oilFlooded: 'Öl überflutet',
  ok: 'OK',
  okCamelCase: 'Ok',
  on: 'Auf',
  onFailureOf: 'Bei Ausfall der',
  oneFallbackOptionShouldBeSelected: 'Es sollte eine Ausweichmöglichkeit gewählt werden',
  oneRuleShouldBeSelected: 'Es sollte eine Regel ausgewählt werden',
  online: 'Online',
  openCloseValve: 'Ventil öffnen/schließen',
  openInsightsReportDescriptionOne:
    'Nachfolgend finden Sie eine Liste aller offenen Einblicke, die sowohl die ausstehenden als auch die in Arbeit befindlichen Maßnahmen anzeigt.',
  openInsightsReportDescriptionTwo:
    'Für weitere Erklärungen und Analysen wenden Sie sich bitte an Ihren Kundenbetreuer.',
  openInsightsReportFooterText: 'Auf dem Dashboard von Ecoplant 360 können Sie weitere Details zu den Werten erkunden.',
  'operation mode': 'Betriebsmodus',
  optOut: 'Ablehnen',
  optimize: 'OPTIMIEREN',
  'optimize-not-controlled-station': 'Stationssteuerung Typ',
  'optimize-not-controlled-station-subtitle': 'Steuerungsmethode für diese Station einstellen',
  or: 'Oder',
  orPurchaseNow: 'Oder jetzt kaufen',
  'order-purchase-number': 'Bestellung Einkaufsnummer',
  overlappingDates: 'Sich überschneidende Daten sind nicht gültig',
  updateLeakAudit: 'Leckprüfung aktualisieren',
  updateAudit: 'Prüfung aktualisieren',
  leakAuditUpdatedSuccessfully: 'Leckprüfung erfolgreich aktualisiert',
  theAuditDatesHaveBeenUpdated: 'Die Prüfungsdaten wurden aktualisiert',
  leakAuditUpdatedAndPublishedSuccessfully: 'Leckentwurf wurde an den Kunden veröffentlicht',
  errorUpdatingLeakAudit: 'Fehler beim Aktualisieren der Leckprüfung',
  leakAuditRejectedSuccessfully: 'Leckprüfung erfolgreich abgelehnt',
  errorRejectingLeakAudit: 'Fehler beim Ablehnen der Leckprüfung',
  leakAuditBookedSuccessfully: 'Leckprüfung erfolgreich gebucht',
  scheduleLeakAudit: 'Leckprüfung planen',
  setAudit: 'Prüfung festlegen',
  reviewLeakAudit: 'Leckprüfung überprüfen',
  rejectAudit: 'Prüfung ablehnen',
  updateAndPublish: 'Aktualisieren und veröffentlichen',
  viewLeak: 'Leck anzeigen',
  overview: 'Übersicht',
  oxidationReductionPotential: 'Oxidations-Reduktionspotenzial',
  oxidationReductionPotentialSensor: '$t(oxidationReductionPotential) Sensor',
  pH: 'PH-Wert',
  package: 'Paket',
  packageCare: 'PaketCARE',
  packageCareStatus: 'PaketCARE Status',
  packageCareTooltip: 'ID: {{careAgreementId}} - Endet: {{endDate}}',
  packagecare: 'Paket',
  packagecarepmonly: 'Nur PM',
  parts: 'Teile',
  'parts-arrived-date': 'Teile sind am',
  'parts-tracking': 'Teileverfolgungsnummer',
  partscare: 'Teile',
  'peak production delta increase part1': 'Ihre Druckluftproduktion hat sich von Monat zu Monat um erhöht',
  'peak production delta increase part2':
    'Was entweder auf ein Produktionswachstum oder auf ein potenzielles Wachstumsdefizit hindeutet',
  pendingTasksOnly: 'Nur ausstehende Aufgaben',
  perAsset: 'Per compressor',
  performance: 'Leistung',
  performanceKpisCalculated: 'Leistungskennzahlen werden berechnet.',
  phSensor: '{pH-Sensor (pH_0)',
  phoneNumber: 'Rufnummer',
  picturesAvailableCount: '{{count}} Bilder verfügbar',
  pidChanges:
    'Neue Triebwerksstrategie muss definiert und veröffentlicht werden, da sich das P&ID der Station geändert hat.',
  'Below is the list of assets  that affect the control strategy:"':
    'Neue Triebwerksstrategie muss definiert und veröffentlicht werden, da sich das P&ID der Station geändert hat.',
  pidMap: 'P&ID-Karte',
  'pipe diameter': 'Rohrdurchmesser',
  planned: 'Geplant',
  'planned-installation-date': 'Geplantes Installationsdatum',
  plannedcare: 'Geplant',
  platform: 'Plattform',
  'po-valid': 'PO Gültig',
  portuguese: 'Portugiesisch',
  possiblecause: 'Mögliche Ursache:',
  power: 'Leistung',
  powerSensor_variableSpeedDrive: '$t(variableSpeedDrive)',
  powerUsersOnly: 'Nur für Power-User',
  predictiveAlgorithms:
    'Prädiktive Algorithmen bewerten Ihren täglichen, wöchentlichen und saisonalen Energieverbrauch und steuern die Systeme dynamisch über Produktionsprofile, um Energieverschwendung, Redundanz und überhöhte Energiekosten zu minimieren.',
  pressure: 'Druck',
  pressureFactor: 'Offset des Entlastungsprüfdrucks',
  pressureForEmergencyStart: 'Druck für den Notstart eines Kompressors',
  pressureForReloadingCompressor: 'Druck für das Wiederaufladen eines Kompressors',
  pressureForStartingCompressor: 'Druck zum Starten eines Kompressors',
  pressureKPIModified: 'Druck KPI geändert:',
  pressureLevels: 'DRUCKBEREICHE',
  pressureRanges: 'Druckbereiche',
  pressureSensor: '$t(Drucksensor)',
  pressureSensorKPI: 'Drucksensor KPI',
  pressureSensorsFallback: 'Drucksensoren Fallback',
  pressureSensorsPriority: 'AUSWAHL DER DRUCKSENSOREN',
  pressureSensorsSelection: 'Auswahl der Drucksensoren',
  pressureSetpoints: 'Drucksollwerte',
  pressureType: 'Drucktyp',
  pressuredrop: 'Druckabfall - Tabelle auswählen',
  pressureranges: 'Druckbereiche',
  previous: 'Zurück',
  priority: 'Priorität',
  priorityEmptyMessage: 'Priorität sollte nicht leer sein',
  priorityUniqueValueMessage: 'Jeder Kompressor muss einen eindeutigen Prioritätswert haben',
  probabilityOfStationHighPressureValues: 'Wahrscheinlichkeit von Stationshochdruckwerten',
  probabilityofharmingcompressorshealth:
    'Wahrscheinlichkeit der Schädigung der Gesundheit des Kompressors - Auswahl des Kompressors',
  probabilityofincreasingstationpressure: 'Wahrscheinlichkeit einer Erhöhung des Stationsdrucks',
  probabilityofreducingsavingsbelowthecommitment:
    'Wahrscheinlichkeit, dass die Einsparungen unter die Verpflichtung sinken',
  probabilityofreducingstationpressurebelowminimum:
    'Wahrscheinlichkeit, dass der Stationsdruck unter den Mindestdruck sinkt',
  problematicFlowLevels: 'Problematische Durchflussmengen',
  problematicPressureRanges: 'Problematische Druckbereiche',
  problematicSetpointsForCompressor: 'Problematische Sollwerte für Kompressor',
  production: 'Produktion',
  productionFloor: '$t(Produktionsfläche)',
  productionLeakRate: 'Prod. Leckrate',
  productionLeakRateTooltip:
    'Berechnet durch Normierung des Leckagedurchflusses auf den Zieldruck und anschließende Teilung durch den durchschnittlichen Produktionsdurchfluss ({{productionLeakRate}}',
  productionLine: '{{productionLineName}} Zeile',
  proportionalValve: 'Proportional Ventil',
  provideReason: 'Geben Sie einen Grund an',
  psi: 'Psi',
  pt: 'Portugiesisch',
  publish: 'Veröffentlichen',
  publishChange: 'Veröffentlichen Ändern',
  publishChanges: 'Änderungen veröffentlichen',
  publishConfirmation:
    'Alle Konfigurationen der Registerkarten werden veröffentlicht. Bestätigen Sie, um fortzufahren.',
  'publishConfirmationEngine1.0':
    'Diese Station wird von Dynamic Controller Version 1.0 verwaltet. Um die Version 1.5 zu aktualisieren, gehen Sie bitte zu ReTool und ändern Sie die Engine-Version auf 1.5. Sobald dies geschehen ist, wird diese veröffentlichte Version die Station verwalten.',
  publishDraftConfirmation:
    'Wirklich Sie alle Änderungen auf allen Konfigurationsregisterkarten veröffentlichen möchten?',
  publishRecommendationConfirmation:
    'Diese Version wird direkt in der Produktion{{draftVersionText}} veröffentlicht. Möchten Sie fortfahren?',
  published: 'Veröffentlicht',
  publishedOn: 'Veröffentlicht am',
  range: 'Bereich',
  rangesAreMandatory: '$t({{ranges}}) sind obligatorisch',
  realTimeData: 'Daten in Echtzeit',
  'realtime flow over max available flow error':
    'Der Echtzeitwert {{realtime}} liegt über dem maximal verfügbaren Durchfluss {{totalFlow}}.',
  'realtime flow over peak error':
    'Fehler – Echtzeitwert {{realtime}} liegt über dem Spitzendurchfluss {{peakSupplyFlow}}. Wenden Sie sich an den Ecoplant-Support',
  'realtime flow over total flow error':
    'Der Echtzeitwert {{realtime}} liegt über dem Gesamtstationsdurchfluss {{totalFlow}}.',
  reason: 'Grund',
  reciprocating: 'Hubarbeitsbühne',
  recommendation: 'Empfohlen',
  recommendationFlowLevelsChanged:
    'Durchflussmengen oder Druckbereiche wurden geändert, daher sind die bestehenden Ausweichregeln ungültig und wurden entfernt.',
  recommended: 'Empfohlen',
  refreshEngine: 'Wenn Sie die Motorversion aktualisiert haben, aktualisieren Sie die Parameter, um sie zu bearbeiten.',
  refrigeratedAirDryer: '$t(Kühllufttrockner)',
  refrigerating: 'Kühlung',
  rejected: 'Abgelehnt',
  'relative position': 'Relative Position',
  remoteControlSupported: 'Steuerung Unterstützt',
  remoteControlUnsupported: 'Steuerung nicht unterstützt',
  repeatEvery: 'Wiederholen Sie alle',
  repeatOn: 'Wiederholen Sie auf',
  requestTierConfirmationMessageLine1: 'Nachricht wird an Ecoplant gesendet',
  requestTierConfirmationMessageLine2: 'Wir werden Sie sofort kontaktieren',
  required: 'Erforderlich',
  restAlerts: '… und {{restAlertsCount}} weitere Alarme',
  result: 'ERGEBNIS',
  revertConfirmation:
    'Sie beantragen, dass die bestehende Strategie mit der Version {{version}} überschrieben wird. Wenn Sie zu dieser Version zurückkehren, wird eine neue Strategie veröffentlicht, die den bestehenden Entwurf überschreibt. Möchten Sie fortfahren?',
  revertPublishedVersion:
    'Wenn Sie zur vorherigen Version zurückkehren, wird eine neue Strategie veröffentlicht, die den bestehenden Entwurf außer Kraft setzt. Möchten Sie fortfahren?',
  revertToDefaultBaselineStrategy:
    'Wirklich Sie den vorhandenen Entwurf mit den Standard-Basiskonfigurationen überschreiben wollen?',
  revertToLastPublished: 'Zurückkehren zur letzten Veröffentlichung',
  revertToPublished: 'Zurückkehren zu Veröffentlicht',
  revertToPublishedConfirmation:
    'Wirklich Sie die Konfigurationen mit den aktuell veröffentlichten überschreiben wollen?',
  reviewAgain: 'Erneute Überprüfung',
  reviewYourSystemPerformance: 'Überprüfen Sie die Leistung und den Zustand Ihres Systems',
  roomConfigurationStepLabel: 'Vermögenswerte zuweisen',
  rotation: 'Drehung',
  rule: 'Regel',
  ruleGenerator: 'Regelgenerator',
  rules: 'Regeln',
  rulesEditor: 'Regeln Editor',
  rulesGenerator: 'Regelgenerator',
  rulesOverview: 'Regeln',
  run: 'Ausführen',
  sampledFlowDuringShutdownTooltip: 'Durchfluss bei Abschaltung ({{sampledFlowDuringShutdown})',
  save: 'Speichern',
  saveAndExit: 'Speichern & Ausstieg',
  saveChanges: 'Speichern von Änderungen',
  saveExitSiteSurvey: 'Speichern und Beenden der Umfrage vor Ort?',
  saved: 'GESPEICHERT',
  savingsBasedOn: 'Einsparungen auf der Grundlage der optimierten Systemeffizienz',
  savingsOpportunity: 'EINSPARMÖGLICHKEIT',
  scrollToBottom: 'Nach unten blättern',
  scrollToTop: 'Nach oben blättern',
  searchStation: 'Bahnhof suchen',
  second: 'Sekunde',
  seconds: 'Sekunden',
  selectAccount: 'Konto auswählen',
  selectCauseError: 'Wählen Sie einen möglichen Grund für die Ablehnung',
  selectCompressorCauseError: 'Wählen Sie mindestens einen Kompressor für die mögliche Ursache aus',
  selectCompressorError: 'Wählen Sie mindestens einen Kompressor aus dem Grund',
  selectFormStation: 'Sender auswählen',
  selectLanguage: 'Sprache auswählen',
  selectReasonError: 'Wählen Sie einen Grund für die Ablehnung',
  selectTableError: 'Wählen Sie mindestens eine Tabelle aus',
  selectTier: 'Stufe auswählen',
  selecttables: 'Tische auswählen',
  sensorFlowCombinationMustBeUnique: 'Kombination der Sensor-Durchfluss-Konfiguration muss eindeutig sein',
  sensorPriorityInfoMessage: 'Im Falle eines Fehlers wird die folgende Logik ausgeführt',
  sensors: 'Sensoren',
  sensorsAreMandatory: 'Sensoren sind obligatorisch',
  sensorsConfiguration: 'Sensoren Konfiguration',
  sensorsKPIConfiguration: 'Sensoren KPI Konfiguration',
  sensorsLogic: 'Sensoren Logik',
  sensorsPriorityResult: 'ERGEBNIS',
  sensorsSelection: 'KPI Konfiguration',
  serialNumber: 'Seriennummer',
  service: 'Dienstleistung',
  serviceDueIn: 'Dienst fällig in {{hours}h',
  serviceInformation: 'Informationen zum Dienst',
  serviceType: 'Art der Dienstleistung',
  setpointChangeInterval: 'Offset-Frequenz der Entlastungsprüfung',
  setpointsLoadUnloadValidation: 'Entlastungssollwert muss höher sein als der Lastsollwert.',
  setpointsMinMaxValidation: 'Drucksollwerte für dieses Gerät müssen zwischen {{minValue}} und {{maxValue}} liegen.',
  setpointsSetTo: 'Sollwerte werden eingestellt auf:',
  setpointsforcompressor: 'Sollwerte für Verdichter - Verdichter auswählen + Tabelle auswählen',
  settings: 'Einstellungen',
  shouldNotBeEmpty: 'Sollte nicht leer sein',
  showAll: 'Alle anzeigen',
  showAllRows: 'Alle Zeilen anzeigen',
  showInDeviceStatus: 'Im Gerätestatus anzeigen',
  showLess: 'Weniger anzeigen',
  showWithPagination: 'Mit Paginierung anzeigen',
  shutdown: 'Abschalten',
  simpleControl: 'STEUERUNG',
  simpleControlDescription:
    'Mit der einfachen Steuerung verbessern Sie die Gesamteffizienz und Auslastung Ihrer Anlage und reduzieren die Laufzeit von Reserve- und Mietkompressoren. Dies hilft Ihnen, die Energiekosten Ihres Systems erheblich zu senken.',
  simpleControlEngine: 'Einfacher Steuerungsmotor',
  simulationValue: '(Simulationswert)',
  singleRuleForAllFlowLevels: 'Einzige Regel für alle Flow Levels',
  siteAddress: 'Adresse des Standorts',
  siteConfigurationStepLabel: 'Standortkonfiguration definieren',
  siteFormAlreadyExists: 'Für dieses Konto existiert bereits eine Standortbestimmung',
  siteSurveyRemoveCompressor: 'Kompressor entfernen',
  spanish: 'Spanisch',
  'specific power': 'Spezifische Leistung',
  spillValve: 'Überlauf Ventil',
  stageDryScrew: 'Stufe Trockenschnecke',
  'staging-end-date': 'Enddatum der Inszenierung',
  standalone: 'Eigenständig',
  startButton: "Los geht's",
  startDate: 'Datum des Beginns',
  startEnd: 'Anfang - Ende',
  startIntegrationProcess: 'Und starte den Integrationsprozess.',
  startNewSurvey: 'Neue Umfrage starten',
  startOneMonthTrial: 'Monat Probezeit beginnen',
  'station-as-built': 'Station wie gebaut',
  stationControlDefaultSetpointsBaseline:
    'Sie sind dabei, den dynamischen Regler zu deaktivieren. Die Station wird auf Basissollwerte zurückgesetzt. Bitte bestätigen Sie und teilen Sie den Grund für die Deaktivierung mit',
  stationControlDefaultSetpointsCustom:
    'Sie sind dabei, den dynamischen Regler zu deaktivieren. Die Station wird auf benutzerdefinierte Sollwerte zurückgesetzt. Bitte bestätigen Sie und teilen Sie den Grund für die Deaktivierung mit',
  stationParameters: 'Parameter der Station',
  stationParametersMissing: 'Einige der Stationsparameter fehlen',
  stationStageCancelButton: 'Abbrechen',
  stationStageDeprecateButton: 'Station verwerfen',
  stationStageDeprecateConfirm: 'Wirklich Sie fortfahren wollen? Diese Aktion kann nicht rückgängig gemacht werden.',
  stationStageDeprecateConsequences1: 'Deaktivieren Sie alle Systemsteuerungen für die Station.',
  stationStageDeprecateConsequences2: 'Verhinderung weiterer Datenerhebungen und Aktualisierungen.',
  stationStageDeprecateConsequences3: 'Archivieren Sie den Sender für historische Zwecke.',
  stationStageDeprecateTitle: 'Station verwerfen',
  stationStageDeprecateWarning:
    'Sie sind dabei, diese Station in einen veralteten Status zu versetzen. Diese Aktion wird:',
  stationStageError: 'Aktualisierung der Bühne fehlgeschlagen. Bitte versuchen Sie es erneut.',
  stationStageMoveTo: 'Umzug nach',
  stationStageNoStageSelected: 'Keine Stufe ausgewählt',
  stationStageState: 'Staat',
  stationStageStatus: 'Station Status',
  stationStageUpdated: 'Bühne erfolgreich aktualisiert',
  stationStageUpdating: 'Aktualisierungsphase.',
  stayAndContinue: 'Aufenthalt & Weiter',
  stopDelayMinutes: 'Stoppverzögerung Minuten',
  stopDelayMinutesEmptyMessage: 'Stoppverzögerungsminuten sollten nicht leer sein',
  success: 'Erfolg',
  successPublish: 'Erfolgreich veröffentlichte Änderungen',
  successPublishDesc: 'Dynamische Controller läuft jetzt mit den veröffentlichten Parametern.',
  suchAs: 'Wie Systemdruck, Durchfluss, Leistung und spezifische Leistung;',
  sum: 'Summe',
  system: 'System',
  systemControl: 'Systemsteuerung',
  systemHealthStatus: 'Status des Systemzustands',
  systemInsights: 'Einblicke in das System',
  systemTrends: 'System-Trends',
  systemView: 'WISSEN - SYSTEM',
  systemViewDescription:
    'Schalten Sie eine umfassende Überwachung Ihrer Systemleistung durch eine individuelle P&ID-Karte, Systemtrends, Systemrisikoüberwachung und zusätzliche Systemeinblicke frei, um Ihre gesamte Systemleistung und -gesundheit zu verbessern.',
  systemcare: 'System',
  target: 'TRG',
  targetPressure: 'Ziel Druck',
  targetSetpoint: 'Ziel-Sollwert',
  temperature: 'Temperatur',
  testCompletedSuccessfully: 'Test erfolgreich abgeschlossen',
  thankInterestCare: 'Vielen Dank für Ihr Interesse an CARE',
  theme: 'Thema',
  thisPressureLevel: 'Dieses Druckniveau',
  tierRequired: 'Wählen Sie eine Stufe',
  time: 'Zeit',
  timeBetweenUnoadingStop: 'Zeit zwischen Entladung und Halt (min.)',
  timer: 'Zeitgeber',
  tm: 'TM',
  toAnalyzeAndOptimize: 'Um Ihre Systemleistung auf der Grundlage historischer Daten zu analysieren und zu optimieren.',
  toContinouslyOptimize: 'Zur kontinuierlichen Optimierung der Systemeffizienz und der Kompressorauslastung',
  toProvideComprehensiveOverview:
    'Umfassenden Überblick über die gesamten Energieeinsparungen (pro Tag, Monat, Jahr & insgesamt) auf der Grundlage der optimierten Systemeffizienz im Vergleich zu Ihrem ursprünglichen Betrieb zu geben',
  toRecord: 'Um Ihr System {{field}} korrekt aufzuzeichnen,',
  toRecordPerformance: 'Um Ihre Leistung genau zu erfassen,',
  total: 'Gesamt',
  totalPlant: 'Gesamtanlage',
  totalProductionFlow: 'Produktionsfluss insgesamt',
  totalWasteFlow: 'Gesamtabfallstrom',
  'training-meeting-date': 'Kundenschulung',
  'training-session-summary': 'Zusammenfassung der Schulungseinheit',
  true: 'Wahr',
  turnOffEngine: 'Motor abstellen',
  un: 'UN',
  units: 'Einheiten',
  unload: 'Entladen',
  unloadBand1: 'Entladen von Band 1',
  unloadBand2: 'Band 2 entladen',
  unloadTestFailed: 'Entlastungstest fehlgeschlagen',
  unloadTestNotTested: 'Entlastungsprüfung nicht durchgeführt',
  unresolvedCompressorStates: 'Ungelöste Kompressorzustände',
  uploadImageBackToUpload: 'Zurück zum Hochladen',
  uploadImageComputerHelperText: 'Klicken Sie oder ziehen Sie Dateien in diesen Bereich zum Hochladen',
  uploadImageDownloadError: 'Bild {{filename}} konnte nicht heruntergeladen werden.',
  uploadImageEditButtonText: 'Tag ändern',
  uploadImageEditSaveButtonText: 'Änderungen speichern',
  uploadImageError: 'Datei {{filename}} konnte nicht hochgeladen werden. Bitte versuchen Sie es erneut.',
  uploadImageFileLimitErrorMessage: 'Sie können nur bis zu {{limit}} Bilder hochladen',
  uploadImageFromGalleryButtonText: 'Aus der Galerie hochladen',
  uploadImageImageTaggingHelperText:
    'Klicken Sie auf das entsprechende Tag, um es auf das Bild anzuwenden. Bitte beachten Sie, dass jedes Bild markiert werden muss',
  uploadImageMaxSizeError: '{{filename}} Größe überschreitet das Limit von {{maxSize}}MB',
  uploadImageMobilePreviewContinueButtonText: 'Weiter zur Bildmarkierung',
  uploadImageMobilePreviewHelperText: 'Bilder zum Einschließen',
  uploadImageMobileSelectHelperText:
    'Machen Sie Fotos oder laden Sie klare Fotos hoch, um uns bei der ordnungsgemäßen Dokumentation dieses Kompressors zu helfen. Versuchen Sie, Bilder von Folgendem zu machen:',
  uploadImageOpenWizzardButton: 'Bilder hochladen',
  uploadImagePopoverTitle: 'Bilder zu diesem Kompressor hinzufügen',
  uploadImageRules: 'Laden Sie bis zu {{limit}} {{maxSize}}MB-Dateien hoch (JPEG, JPG, PNG, HEIF, HEIC)',
  uploadImageStepHelperText:
    'Laden Sie klare Fotos hoch, um uns bei der ordnungsgemäßen Dokumentation dieses Kompressors zu helfen.',
  uploadImageTagControllerBack: 'Controller Rückseite',
  uploadImageTagControllerFront: 'Controller Vorderseite',
  uploadImageTagElectricalCabinet: 'Elektroschrank',
  uploadImageTagIncomingWiring: 'Eingehende Verkabelung',
  uploadImageTagMachineDataTag: 'Maschinendaten-Tag',
  uploadImageTagOther: 'Andere',
  uploadImageTagPipeFocused: 'Rohr (Fokussiert)',
  uploadImageTagPipePanoramaVideo: 'Rohr (Panorama/Video)',
  uploadImageTagSensor: 'Sensor',
  uploadImageTaggingError: 'Bitte markieren Sie alle Bilder, bevor Sie fortfahren',
  uploadImageTaggingTitle: 'Markieren Sie, was jedes Foto zeigt',
  uploadImageTagsDrawerTitle: 'Versuchen Sie, Folgendes einzuschließen:',
  uploadImageTakePictureButtonText: 'Ein Foto machen',
  uploadImageTitle: 'Fotos für diesen Kompressor hinzufügen',
  uploadImageUnifiedButtonAddAnotherText: 'Ein weiteres Foto hinzufügen',
  uploadImageUnifiedButtonText: 'Bilder hinzufügen',
  uploadPictures: 'Bilder hochladen',
  upperBoundFlow: 'Obere Grenze Fluss',
  upperBoundPressure: 'Obere Grenze Druck',
  userAssociatedStations: 'Assoziierte Stationen',
  userName: 'Name des Benutzers',
  userUnitOfMeasure: 'Benutzereinheit',
  validationForGreaterThan: '{{title}} muss größer sein als {{min}} {{unit}} SEIN.',
  validationForMinMax: '{{title}} muss zwischen {{min}} und {{max}} liegen {{unit}} LIEGEN.',
  validationForMinTargetLessThanMaxTarget: 'Minimalziel muss kleiner sein als das Maximalziel.',
  value: 'Wert {{currency}}',
  valueDashboard: 'Wert Dashboard',
  valueType: 'Wert Typ',
  variableSpeedDrive: 'Kompressor mit variabler Drehzahl',
  version: 'Version',
  versionHistory: 'Versionsgeschichte',
  versionRevertError: 'Fehler beim Zurücksetzen der Version',
  versionRevertedSuccess: 'Version erfolgreich rückgängig gemacht',
  viewMode: 'Ansichtsmodus',
  viewPastAlerts: 'Sehen Sie vergangene Warnungen in der Registerkarte Archiv.',
  viewReason: 'Ansicht Grund',
  viewReport: 'Bericht ansehen',
  vsdTarget: 'Ziel',
  warning: 'Warnung',
  waste: 'Abfall',
  waterCooled: 'Wassergekühlt',
  waterPressureSensor: 'Wasserdrucksensor',
  week: 'Woche',
  weeks: 'Wochen',
  welcomeDescription:
    'Konfigurieren Sie einen genauen, kundenspezifischen Lageplan. Geben Sie die Salesforce-Konto-ID ein, um eine neue Umfrage zu starten oder eine bestehende fortzusetzen.',
  welcomeSteps: 'Fügen Sie zunächst die Salesforce-Konto-ID hinzu und folgen Sie dann diesen 3 einfachen Schritten',
  welcomeTitle: 'Welcome to the site survey',
  wetAirTank: '$t(Nasslufttank)',
  wizard: 'Zauberer',
  workingHours: 'Arbeitszeiten',
  wrongcompressorcombinations: 'Falsche Kompressorkombination - Tabelle auswählen',
  years: '< {{years}} Jahre',
  yes: 'Ja',
  yourCurrentVersion: 'Ihre aktuelle Version',
  ytdTooltip: 'Daten werden monatlich aktualisiert',
  ytdValue: 'YTD WERT',
  '{{value}} {{unit}} average': '{{value}} {{unit}} Durchschnitt',
  '°C': '°C',
  '°F': '°F',
  mixedStationNotSupported: 'Engine 1.5 unterstützt derzeit keine gemischten Stationen',
  compressorNumber: 'Kompressornummer',
  Skip: 'Überspringen',

  // Report Tab Page
  reportDetails: 'Berichtdetails',
  dateCreated: 'Erstellt am',
  createdBy: 'Erstellt von',
  status: 'Status',
  totalReports: 'Bericht',
  createNewReport: 'Neuer Bericht',
  searchByDateCreatorOrStatus: 'Suchen nach Datum, Ersteller oder Status',
  inProgress: 'In Progress',
  failed: 'Fehler',
  inDraft: 'Entwurf',
  unknown: 'Unbekannt',
  failedToDownloadReportFile: 'Fehler beim Herunterladen des Berichts',
  downloadingFile: 'Datei wird heruntergeladen...',
  fileDownloaded: 'Datei erfolgreich heruntergeladen',
  deleteReport: 'Bericht löschen',
  areYouSureYouWantToDeleteThisReport: 'Sind Sie sicher, dass Sie diesen Bericht löschen möchten?',
  reportDeletedSuccessfully: 'Bericht erfolgreich gelöscht',
  failedToDeleteReport: 'Fehler beim Löschen des Berichts',
  failedToUploadReport: 'Fehler beim Hochladen des Berichts',
  reportUploadedSuccessfully: 'Bericht erfolgreich hochgeladen',
  anErrorOccurred: 'Ein Fehler ist aufgetreten',
  onlyPowerPointFilesAllowed: 'Nur PowerPoint-Dateien (.pptx, .ppt) sind erlaubt',
  pleaseSelectADateRange: 'Bitte wählen Sie ein Datumsbereich',
  reportRequestedSuccessfully:
    'Die Berichtserstellung kann bis zu 15 Minuten dauern. Sobald sie abgeschlossen ist, ändert sich der Status in Entwurf und die Bearbeitungs- und Veröffentlichungsaktionen werden aktiviert.',
  failedToRequestReport: 'Fehler beim Anfragen des Berichts',
  selectDates: 'Datumsbereich auswählen',
  noteForReportGeneration:
    'Hinweis: Die Generierung des Berichts kann einige Minuten dauern. Sie werden per E-Mail benachrichtigt, wenn der Bericht fertig ist.',
  reportTimeFrameUpTo2Weeks: 'Der Berichtszeitraum kann bis zu 2 Wochen betragen.',
  generateReport: 'Bericht generieren',
  reportPublishedSuccessfully: 'Bericht erfolgreich veröffentlicht',
  reportPublishedInProgress:
    'Die Berichtsveröffentlichung kann einige Minuten dauern. Sobald sie abgeschlossen ist, ändert sich der Status in Veröffentlicht, die Ansichtsaktion wird aktiviert und der Kunde kann diesen Bericht sehen.',
  failedToPublishReport: 'Fehler beim Veröffentlichen des Berichts',
  addBusinessImpactBeforePublishing: 'Geschäftliche Auswirkung vor der Veröffentlichung hinzufügen',
  pleaseEstimateItsPotentialBusinessImpact:
    'Bitte schätzen Sie die potenzielle Geschäftliche Auswirkung. Dies hilft bei der Kommunikation des Berichts Werts an Ihren Kunden.',
  estimatedValue: 'Geschätzter Wert ($)',
  valueIsRequiredAndMustBeHigherThan0ToPublish:
    'Wert ist erforderlich und muss größer als 0 sein, um zu veröffentlichen',
  noteOncePublishedThisReportWillBeAutomaticallySharedWithAllRecipients:
    'Hinweis: Nach der Veröffentlichung wird dieser Bericht automatisch mit allen Empfängern geteilt.',
  publishReport: 'Bericht veröffentlichen',
  Upload: 'Hochladen',
  Publish: 'Veröffentlichen',
  View: 'Ansehen',
  seeTheFullPictureOfYourReportPerformance: 'Sehen Sie sich die vollständige Leistung Ihres Berichts an',
  createAToTrackAnalyzeAndSharePerformance:
    'Erstellen Sie einen Bericht, um die Leistung zu verfolgen, zu analysieren und zu teilen',
  tryNewReport: 'Neuer Bericht ausprobieren',
  loadingReports: 'Berichte werden geladen...',
  generatingReports: 'Berichte werden generiert...',
  noReportsAvailable: 'Keine Berichte verfügbar',
  sentForPublishing: 'Zur Veröffentlichung gesendet',
  kpiChanges:
    'Eine neue Triebwerksstrategie muss definiert und veröffentlicht werden, da sich die Sensoren KPI Konfiguration geändert hat. Bitte überprüfen Sie die Änderungen und veröffentlichen Sie die Konfiguration.',
  kpiChangesAndPIDChanges:
    'Eine neue Triebwerksstrategie muss definiert und veröffentlicht werden, da sich die Station P&ID und Sensoren KPI Konfiguration geändert hat. Unten ist die Liste der Assets, die die Steuerstrategie beeinflussen:',
  dynamicControlInvalidStationStage:
    'Die dynamische Steuerung kann nicht aktiviert werden, da sich die Station nicht im Abonnement-/Vorbereitungsmodus für die Steuerung befindet.',
  fallbackScenarioForAllCompressorsFailureCannotBeDefined:
    'Fallback-Szenario für alle Kompressorfehler kann nicht definiert werden',
  loadingDocument: 'Dokument wird geladen...',
  ignoreFallbackCompressors: 'Kompressoren, die von der Fallback-Szenario-Generierung ausgeschlossen sind',
  ignoreFallbackCompressorsTooltip:
    'Fallback-Szenarien werden nur für einen definierten Satz von Kompressoren generiert. Dieser Satz wird durch den Schnittpunkt von bestimmt:',
  ignoreFallbackCompressorsTooltipBullet1: 'Derzeit im System verfügbare Kompressoren',
  ignoreFallbackCompressorsTooltipBullet2: 'Kompressoren, die nicht in der Ausschlussliste enthalten sind.',
  ignoreFallbackCompressorsTooltipNote:
    'Die hier aufgeführten Kompressoren werden von der Fallback-Strategie absichtlich ignoriert—zum Beispiel, weil sie als getrennt bekannt sind oder weil kein Fallback erforderlich ist, wenn sie ausfallen.',
};

export default de;
